import React, { useState, useEffect, useRef, useCallback,useMemo } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { io } from 'socket.io-client';
import * as mediasoupClient from 'mediasoup-client';
import { getOptimizedAudioConstraints, detectEarphones } from './audioConstraints';
import ChatComponent from './ChatComponent';
import AudioPermissionModal from './AudioPermissionModal';
import ScreenAnnotationWhiteboard from './components/ScreenAnnotationWhiteboard'; // 👈 ✅ YEH LINE ADD KARO
import StreamerWhiteboard from './components/WhiteboardComponent';
import { Dialog } from "@headlessui/react";
import ThumbnailsPanel from "./components/panels/ThumbnailsPanel";
import MainStage from "./components/panels/MainStage";
import { toast } from 'react-toastify';
import { useMediaProcessors } from './useMediaProcessors';
import { StartRecordingModal, StopRecordingModal } from './components/RecordingModals'; // Path apne hisaab se adjust kar lena
// Agar aapne in files ko components folder ke andar banaya hai, toh path kuch aisa hoga:yyyyy
import StreamHeader from './components/StreamHeader';
// File ke top par jahan baaki components import ho rahe hain
import ShareTypeModal from './components/ShareTypeModal'; // Path apne folder structure ke hisaab se adjust kar lena
import BottomControls from './components/BottomControls';
import StreamSidebar from './components/StreamSidebar';
import StreamLoadingStates from './components/StreamLoadingStates';
import StartResumePromptModal from './components/StartResumePromptModal';
import { useLiveConnection } from './useLiveConnection'; // Naya import
import { FiVideo, FiVideoOff, FiMic, FiMicOff,FiCamera, FiCameraOff,FiEdit3 ,FiUsers, FiMessageSquare,FiChevronRight, FiChevronLeft,
  FiPlay, FiPause, FiStopCircle,FiCheck, FiX,FiLoader,FiLogOut,FiAlertCircle,FiMaximize,FiCircle,FiMonitor,FiRadio,
  FiVolume,FiVolume2,FiVolume1} from 'react-icons/fi';
import { MdOutlineScreenShare, MdStopScreenShare,MdPlayArrow,MdPause,MdStop,MdVolumeOff} from 'react-icons/md';
import { TfiHandOpen } from "react-icons/tfi";
import { createPortal } from "react-dom";
import { BsFillRecordFill } from "react-icons/bs";
import { useRecordingTimer, RecordingTimerDisplay, RecordingStatusBadge,formatTime } from './RecordingTimer';

import { ActiveViewerAudioPanel,ActiveScreenSharesPanel,ProducerStatus,ParticipantsModal,ViewerVideoRequestsPanel,ViewerAudioRequestsPanel,ScreenShareRequestsPanel,
  MobileHeader,MobileNavigation,MobileRequestsPanel,MobileControls,MobileParticipantsView,MobileChatView,MobileVideoView,ThumbnailVideo
} from './components';


const LiveSession = () => {
  const [showAudioModal, setShowAudioModal] = useState(false);
  // Banned users track karne ke liye state
  const [bannedUsers, setBannedUsers] = useState([]);
  const [showEchoSync, setShowEchoSync] = useState(false);
const [whiteboardSessionInfo, setWhiteboardSessionInfo] = useState(null);
// Screen share type state
const [showShareTypeModal, setShowShareTypeModal] = useState(false);
// Viewer screen share ke liye alag state
const [viewerScreenShare, setViewerScreenShare] = useState(null);
const [appViewerScreenShare, setAppViewerScreenShare] = useState(null);
const [isPromptDismissed, setIsPromptDismissed] = useState(false);
  // Existing states में add करें:
const [screenCaptureStream, setScreenCaptureStream] = useState(null);
const [screenCaptureActive, setScreenCaptureActive] = useState(false);
const [recordingSource, setRecordingSource] = useState(null); // 'screen' or 'camera'
  const [pendingScreenShare, setPendingScreenShare] = useState(null);
  const { sessionId, roomCode } = useParams();
  const navigate = useNavigate();
  const { user, token } = useAuth();
  const [socket, setSocket] = useState(null);
  const [showWhiteboard, setShowWhiteboard] = useState(false);
const [recordings, setRecordings] = useState([]);
const [showRecordingsModal, setShowRecordingsModal] = useState(false);
const [isRecordingLoading, setIsRecordingLoading] = useState(false);
const [isRecordingStopping, setIsRecordingStopping] = useState(false); // ✅ नया state add करें
const [recordingInterval, setRecordingInterval] = useState(null); // ✅ नया state
const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
const [thumbnailsExpanded, setThumbnailsExpanded] = useState(false);
const [fullScreenThumbnails, setFullScreenThumbnails] = useState(false);
const [autoStartRecording, setAutoStartRecording] = useState(false);
const [recordingStream, setRecordingStream] = useState(null);
const [isSpeaking, setIsSpeaking] = useState(false);
const [handRaisedUsers, setHandRaisedUsers] = useState([]);
const [speakingUsers, setSpeakingUsers] = useState(new Map());
const [showStartInstructionModal, setShowStartInstructionModal] = useState(false);
const [showStopConfirmModal, setShowStopConfirmModal] = useState(false);
const [hasRecordingBeenUsed, setHasRecordingBeenUsed] = useState(false); // Track if recording was already done
const [allowedWhiteboardUsers, setAllowedWhiteboardUsers] = useState([]);
const {  recordingTimer,recordingStartTime,isRecordingActive,startRecordingTimer,stopRecordingTimer,resetRecordingTimer,formatRecordingTime } = useRecordingTimer();
const [isLandscape, setIsLandscape] = useState(false);
const [showEndSessionRecordingModal, setShowEndSessionRecordingModal] = useState(false);
// Pagination aur active consumers track karne ke liye
const [viewerVideoPage, setViewerVideoPage] = useState(0);
const activeViewerVideoIdsRef = useRef(new Set());
const connectedAudioSourcesRef = useRef(new Map());
const [pinnedViewerId, setPinnedViewerId] = useState(null);
const VIDEOS_PER_PAGE = 2; // Ek page pe 4 viewer cameras
   const [showAudioPermissionModal, setShowAudioPermissionModal] = useState(false);
  const [userInteracted, setUserInteracted] = useState(false);
  const [pendingAudioStreams, setPendingAudioStreams] = useState(new Map());
   const [uploadingFile, setUploadingFile] = useState(false);
  const [chatInput, setChatInput] = useState('');
const [thumbnailsPosition, setThumbnailsPosition] = useState('right');
const [streamerThumbnailVisible, setStreamerThumbnailVisible] = useState(true);
const [sidebarView, setSidebarView] = useState('participants');
const [isWebSocketInitialized, setIsWebSocketInitialized] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
   const [showEmojiPicker, setShowEmojiPicker] = useState(false);
const [showRequests, setShowRequests] = useState(false);
  const [mobileView, setMobileView] = useState('video');
  const [showMobileControls, setShowMobileControls] = useState(true);
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [showThumbnails, setShowThumbnails] = useState(false);
  const [session, setSession] = useState(null);
  const [participants, setParticipants] = useState([]);
  const videoOnlyStreamCacheRef = useRef(new Map());
  const latestResourcesRef = useRef({ mediaStream: null, screenCaptureStream: null, socket: null });
  const participantNameById = useMemo(() => {
  const m = new Map();
  for (const p of participants) m.set(p.userId, p.name || `User ${p.userId}`);
  return m;
}, [participants]);
  const [messages, setMessages] = useState([]);
  const [isConnected, setIsConnected] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isInitializing, setIsInitializing] = useState(true);
  const [permissionStatus, setPermissionStatus] = useState('checking');
  const [mediaError, setMediaError] = useState(null);
  const [cameraReady, setCameraReady] = useState(false);
  const [cameraVisible, setCameraVisible] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const [showPlayButton, setShowPlayButton] = useState(false);
  const [localPausedState, setLocalPausedState] = useState(false);
  const [audioEnabled, setAudioEnabled] = useState(true);
  const [videoEnabled, setVideoEnabled] = useState(true);
  const [iceServers, setIceServers] = useState([]);
  const [isMediaInitialized, setIsMediaInitialized] = useState(false);
  const [debugLog, setDebugLog] = useState([]);
  const [producersState, setProducersState] = useState(new Map());
  const [consumersState, setConsumersState] = useState(new Map());
  const [isStreamPaused, setIsStreamPaused] = useState(false);
  const [showParticipantsModal, setShowParticipantsModal] = useState(false);
  const [selectedParticipant, setSelectedParticipant] = useState(null);
  const [activeSpeakers, setActiveSpeakers] = useState(new Map());
  const [viewerAudioRequests, setViewerAudioRequests] = useState([]);
  const [screenShareRequests, setScreenShareRequests] = useState([]);
  const [activeViewerAudio, setActiveViewerAudio] = useState(new Map());
  const [activeScreenShare, setActiveScreenShare] = useState(null);
   const [audioRemoveTarget, setAudioRemoveTarget] = useState(null);
   const [zoomed, setZoomed] = useState(null);
  const [mediaStream, setMediaStream] = useState(null);
  const [viewerAudios, setViewerAudios] = useState(new Map());
const [viewerVideoRequests, setViewerVideoRequests] = useState([]);
const [viewerCameras, setViewerCameras] = useState(new Map()); 
const autoZoomedTrackIdRef = useRef(null);
const recordingAudioContextRef = useRef(null);
const recordingDestinationRef = useRef(null);
const speakingSourceRef = useRef(null);
const speakingAudioContextRef = useRef(null);
const mixedAudioProducerRef = useRef(null);
const isRecordingRef = useRef(false);
const screenCaptureStreamRef = useRef(null);
const activeScreenShareRef = useRef(null);
const screenCaptureActiveRef = useRef(false);
const viewerScreenRef = useRef(null);
  const streamerMediaRef = useRef(new MediaStream());
  const viewerAudiosRef = useRef(new Map());
  const userInteractedRef = useRef(false);
const showAudioPermissionModalRef = useRef(false);
const audioModalLockRef = useRef(false);
const isRecordingStartingRef = useRef(false);
const recordingScreenStreamRef = useRef(null);
const recordingVideoProducerRef = useRef(null);
  const videoRef = useRef(null);
  const screenRef = useRef(null);
  const remoteVideosRef = useRef(new Map());
  const transports = useRef(new Map());
  const producers = useRef(new Map());
  const consumers = useRef(new Map());
  const userGestureHandlerRef = useRef(null);
  const isMountedRef = useRef(true);
  const sendTransportRef = useRef(null);
  const recvTransportRef = useRef(null);
  const audioElementsRef = useRef(new Map());
  const pendingAudioQueueRef = useRef(new Map());
  const socketRef = useRef(null);
  const zoomedVideoRef = useRef(null); // ✅ Add this near other refs
  const recordingStopResolveRef = useRef(null);
  const audioContextRef = useRef(null);
const analyserRef = useRef(null);
const speakingDetectionIntervalRef = useRef(null);
const localAudioTrackRef = useRef(null);
const speakingThreshold = 40; // Same as viewer side
const audioDestinationRef = useRef(null);
  const [device] = useState(new mediasoupClient.Device());
  const [showRecorder, setShowRecorder] = useState(false);
  const [isRecording, setIsRecording] = useState(false);
  // 👈 ✅ YEH NAYA BLOCK ADD KARO 👇
const defaultAnnotationInfo = useMemo(() => ({
  title: session?.title || "Screen Annotation",
  roomCode: session?.roomCode || roomCode,
  streamerName: user?.name || "Streamer",
  streamerId: user?.id,
  sessionId: sessionId || roomCode,
  wsToken: token,
  allowViewersToDraw: true,
  isStreamer: true
}), [session, roomCode, user, sessionId, token]);
  // Apne states aur refs ke niche ye add karo:
  const isAudioModalOpen = isRecording && !userInteracted; 
  const addDebugLog = (message) => {
    console.log(message);
    setDebugLog(prev => [...prev.slice(-50), `${new Date().toLocaleTimeString()}: ${message}`]);
  };

  const [roomState, setRoomState] = useState({
    isStreaming: false,
    isPaused: false,
    whiteboardEnabled: true
  });
  const emitSocketEvent = (event, data, callback) => {
    if (socketRef.current && socketRef.current.connected) {
      if (callback) {
        socketRef.current.emit(event, data, callback);
      } else {
        socketRef.current.emit(event, data);
      }
      addDebugLog(`📤 Emitted ${event} event`);
      return true;
    } else {
      addDebugLog(`❌ Cannot emit ${event}: Socket not connected`);
      return false;
    }
  };

  const getSocket = () => {
    return socketRef.current;
  };

  const mediaProcessors = useMediaProcessors({
    states: { 
        mediaStream, socket, sessionId, roomCode, user, 
        activeScreenShare, userInteracted, showAudioPermissionModal 
    },
    setters: {
        setIsSpeaking, setSpeakingUsers, setZoomed, setScreenCaptureStream,
        setScreenCaptureActive, setViewerAudios, setPendingAudioStreams,
        setViewerCameras, setActiveScreenShare, setParticipants,
        setHandRaisedUsers, setActiveSpeakers, setViewerAudioRequests,setAppViewerScreenShare,
        setViewerVideoRequests, setScreenShareRequests, setActiveViewerAudio,
        setViewerScreenShare, setShowAudioPermissionModal
    },
    refs: {
        speakingAudioContextRef, speakingSourceRef, analyserRef,
        speakingDetectionIntervalRef, localAudioTrackRef, sendTransportRef,
        recordingAudioContextRef, recordingDestinationRef,
        viewerAudiosRef, audioElementsRef, pendingAudioQueueRef,
        isRecordingRef, screenCaptureStreamRef, consumers, remoteVideosRef,
        userInteractedRef, viewerScreenRef
    },
    helpers: { addDebugLog }
});

const {
  initializeCamera,
  requestCameraPermissions,
  retryCamera,
  initializeWebSocket,
  initializeMedia,         // ✅ Added
  handlePauseProducer,     // ✅ Added
  handleResumeProducer,    // ✅ Added
  handleCloseProducer,
  createConsumer,  
  forceEncoderKeyframe
} = useLiveConnection({
  // Core Context
  sessionId, roomCode, token, user, device,setAllowedWhiteboardUsers,setBannedUsers,
  // Refs
  videoRef, screenRef, socketRef, sendTransportRef, recvTransportRef,
  producers, consumers, transports, remoteVideosRef, 
  isRecordingRef, viewerScreenRef, pendingAudioQueueRef, isMountedRef, // ✅ Missing refs added
  // States
  mediaStream, isMobile, permissionStatus, isMediaInitialized, setActiveScreenShare,
  roomState, producersState, setActiveViewerAudio,
  // Setters
  setSocket, setIsConnected, setParticipants, setMessages,
  setProducersState, setRoomState, setLocalPausedState,
  setPermissionStatus, setIsLoading, setIsInitializing, setCameraVisible,
  setShowPlayButton, setMediaError, setCameraReady, setIsMediaInitialized,
  setViewerScreenShare, setAppViewerScreenShare, setZoomed, setSpeakingUsers, setHandRaisedUsers,
  setViewerAudioRequests, setScreenShareRequests, setActiveSpeakers,
  setMediaStream, setIceServers, setSession, setViewerVideoRequests,
  setIsPlaying, setIsWebSocketInitialized, setIsRecording, setViewerCameras, // ✅ Missing setters added
  // Helpers & External Processors
  addDebugLog, getSocket, emitSocketEvent, 
  cleanupViewerMedia: mediaProcessors.cleanupViewerMedia,
  cleanupViewerCamera: mediaProcessors.cleanupViewerCamera,
  cleanupScreenShareAudio: mediaProcessors.cleanupScreenShareAudio,
  cleanupOnlyMicrophoneAudio: mediaProcessors.cleanupOnlyMicrophoneAudio,
  cleanupUserOnLeft: mediaProcessors.cleanupUserOnLeft,
  handleAudioConsumer: mediaProcessors.handleAudioConsumer,
  startRecordingTimer // ✅ Added
});
// Ab seedha destructure karke unko file mein waise hi use karo jaise pehle kar rahe the
const {
    startStreamerSpeakingDetection, stopStreamerSpeakingDetection,
    startSpeakingDetection, stopSpeakingDetection, getMixedAudioStream,
    cleanupScreenCapture, cleanupViewerAudio, cleanupViewerCamera,
    cleanupViewerMedia, cleanupScreenShareAudio, cleanupOnlyMicrophoneAudio,
    cleanupUserOnLeft, handleAudioConsumer, playAllAudio, createAndPlayAudioElement
} = mediaProcessors;
  // const thumbnailsCount = (mediaStream ? 1 : 0) + viewerCameras.size + (activeScreenShare ? 1 : 0);
  // Line ~234 par update karo
const thumbnailsCount = (mediaStream ? 1 : 0) + 
                       viewerCameras.size + 
                       (activeScreenShare ? 1 : 0) + 
                       (viewerScreenShare ? 1 : 0)+(appViewerScreenShare ? 1 : 0); // ✅ YEH ADD KARO

  const toggleZoom = (type, stream, userId) => {
  setZoomed((prev) => {
    if (prev && prev.type === type && prev.userId === userId) {
      return null; // unzoom
    }
    return { type, stream, userId };
  });
};

// ✅ BAN PARTICIPANT HANDLER
  const handleBanParticipant = useCallback((userId, userName) => {
    // Confirmation UI pehle hi components me handled hai, but safety ke liye:
    emitSocketEvent('ban_participant', {
      sessionId: sessionId || roomCode,
      targetUserId: userId
    });
    
    // Streamer ki UI mein locally add kar dein taaki list me dikhe aur unban kar sake
    setBannedUsers(prev => {
      if (prev.find(u => u.userId === userId)) return prev;
      return [...prev, { userId, name: userName || 'Unknown User' }];
    });
    
    toast.success("User has been banned.");
    addDebugLog(`🚫 Banned participant: ${userId}`);
  }, [sessionId, roomCode, emitSocketEvent]);

  // ✅ UNBAN PARTICIPANT HANDLER
  const handleUnbanParticipant = useCallback((userId) => {
    emitSocketEvent('unban_participant', {
      sessionId: sessionId || roomCode,
      targetUserId: userId
    });
    
    // UI se hata dein
    setBannedUsers(prev => prev.filter(u => u.userId !== userId));
    
    toast.success("User has been unbanned. They can now rejoin.");
    addDebugLog(`✅ Unbanned participant: ${userId}`);
  }, [sessionId, roomCode, emitSocketEvent]);
const getVideoOnlyStream = useCallback((stream) => {
  if (!stream) return null;

  const track = stream.getVideoTracks?.()?.[0];
  if (!track) return stream;

  const key = track.id; // stable per track
  const cache = videoOnlyStreamCacheRef.current;

  if (cache.has(key)) return cache.get(key);

  const ms = new MediaStream([track]);
  cache.set(key, ms);

  // optional: cleanup when track ends
  track.addEventListener?.("ended", () => {
    cache.delete(key);
  });

  return ms;
}, []);

// Hand control functions
const lowerHandForUser = (userId) => {
  emitSocketEvent('lower_hand', {
    sessionId: sessionId || roomCode,
    targetUserId: userId
  });
  
  toast.info('Hand lowered for user');
  addDebugLog(`✋ Hand lowered for user: ${userId}`);
};

const lowerAllHands = () => {
  if (window.confirm('Lower all raised hands?')) {
    emitSocketEvent('lower_all_hands', {
      sessionId: sessionId || roomCode
    });
    
    setHandRaisedUsers([]);
    toast.success('All hands lowered');
    addDebugLog('🛑 All hands lowered');
  }
};

const startScreenCapture = async (purpose = "share") => {
  try {
    addDebugLog(`🖥️ Starting new screen capture for ${purpose}`);

    const stream = await navigator.mediaDevices.getDisplayMedia({
      video: {
        cursor: "always",
        frameRate: { ideal: 30, max: 30 },
        width: { ideal: 1280 },
        height: { ideal: 720 },
      },
      audio: true,
    });

    // ✅ Set ref FIRST (race-proof)
    screenCaptureStreamRef.current = stream;

    // ✅ Then state
    setScreenCaptureStream(stream);
    setScreenCaptureActive(true);

    // ✅ Track end handler (use refs, not stale state)
    const videoTrack = stream.getVideoTracks?.()[0];
    if (videoTrack) {
      videoTrack.onended = () => {
        addDebugLog("🛑 Screen capture ended by system UI");

        // If streamer share is running -> stop screen share
        if (activeScreenShareRef.current?.source === "streamer") {
          stopScreenShare();
        }

        // Cleanup capture
        cleanupScreenCapture(true);
      };
    }

    addDebugLog(`✅ Screen capture started successfully for ${purpose}`);
    return stream;
  } catch (error) {
    console.error("❌ Screen capture failed:", error);
    toast.error(`Failed to capture screen for ${purpose}`);
    return null;
  }
};

const getOrCreateCapture = async (purpose) => {
  // ✅ Check if existing stream actually has LIVE tracks
  if (screenCaptureStreamRef.current) {
    const hasLiveTracks = screenCaptureStreamRef.current.getTracks().some(t => t.readyState === 'live');
    if (!hasLiveTracks) {
      addDebugLog("⚠️ Existing capture stream has dead tracks, cleaning up...");
      cleanupScreenCapture(true); // Dead stream ko clean karo (ye ref ko null kar dega)
    }
  }
  // Agar zinda hai toh wahi do, warna naya start karo
  return screenCaptureStreamRef.current || (await startScreenCapture(purpose));
};



useEffect(() => {
  if (roomState.isStreaming && !roomState.isPaused) {
    setIsPromptDismissed(false);
  }
}, [roomState.isStreaming, roomState.isPaused]);
useEffect(() => {
    // Component mount hote hi flag set karein
    sessionStorage.setItem("killMediaOnReturn", "true");
    
    // ... aapka baaki ka LiveSession ka code ...
  }, []);

useEffect(() => {
  return () => {
    console.log("🧹 Streamer leaving page. Cleaning up hardware resources...");
    
    // Ref se ekdam latest values nikaalein
    const { mediaStream: latestMedia, screenCaptureStream: latestScreen, socket: latestSocket } = latestResourcesRef.current;

    if (latestMedia) { 
      latestMedia.getTracks().forEach((track) => {
        track.stop();
        console.log(`🛑 Stopped streamer track: ${track.kind}`);
      });
    }

    if (latestScreen) { 
      latestScreen.getTracks().forEach((track) => {
        track.stop();
        console.log(`🛑 Stopped streamer screen track: ${track.kind}`);
      });
    }

    if (latestSocket) {
      latestSocket.emit("streamer-screen-share-stop", { sessionId: sessionId || roomCode });
    }
  };
}, []);
// Check karein ki modal dikhana hai ya nahi
const showStartResumePrompt = (!roomState.isStreaming || roomState.isPaused) && !isPromptDismissed;

useEffect(() => {
  if (!producersState || !socketRef.current || !recvTransportRef.current) return;

  const allViewerProducers = Array.from(producersState.values()).filter(
    p => p.kind === 'video' && p.source === 'viewer-camera'
  );

  const shouldBeActive = new Set();

  if (thumbnailsExpanded) {
    const VIDEOS_PER_PAGE = 3;
    const startIndex = viewerVideoPage * VIDEOS_PER_PAGE;
    const pageProducers = allViewerProducers.slice(startIndex, startIndex + VIDEOS_PER_PAGE);
    pageProducers.forEach(p => shouldBeActive.add(p.id));
  } else {
    let activeProducer = null;
    if (pinnedViewerId) {
      activeProducer = allViewerProducers.find(p => p.userId === pinnedViewerId);
    }
    if (!activeProducer && zoomed?.type === "viewer" && zoomed?.userId) {
      activeProducer = allViewerProducers.find(p => p.userId === zoomed.userId);
    }
    if (activeProducer) {
      shouldBeActive.add(activeProducer.id);
    }
  }

  // 2. 🧹 CLEANUP (Pause instead of destroy to save bandwidth instantly)
  activeViewerVideoIdsRef.current.forEach(producerId => {
    if (!shouldBeActive.has(producerId)) {
      const consumer = consumers.current.get(producerId);
      
      if (consumer && consumer !== "CREATING" && consumer !== "CLOSED_WHILE_CREATING") {
        // ✨ MAGIC FIX: Server aur local dono jagah pause karo, destroy mat karo!
        try { consumer.pause(); } catch(e) {}
        emitSocketEvent('consumer-pause', { 
            sessionId: sessionId || roomCode, 
            consumerId: consumer.id 
        });
      } else if (consumer === "CREATING") {
         consumers.current.set(producerId, "PAUSE_AFTER_CREATION");
      }

      const producerInfo = producersState.get(producerId);
      if (producerInfo) {
        setViewerCameras(prev => {
          const newMap = new Map(prev);
          newMap.delete(producerInfo.userId);
          return newMap;
        });
      }
    }
  });

  // 3. 📥 CONSUME NEW (OR RESUME)
  shouldBeActive.forEach(producerId => {
    if (!activeViewerVideoIdsRef.current.has(producerId)) {
      const consumer = consumers.current.get(producerId);
      
      if (consumer && consumer !== "CREATING" && consumer !== "CLOSED_WHILE_CREATING" && consumer !== "PAUSE_AFTER_CREATION") {
        // Already exists, just resume!
        try { consumer.resume(); } catch(e) {}
        emitSocketEvent('consumer-resume', { 
            sessionId: sessionId || roomCode, 
            consumerId: consumer.id 
        });
        
        const producerInfo = producersState.get(producerId);
        if (producerInfo) {
          setViewerCameras(prev => {
            if (prev.has(producerInfo.userId)) return prev;
            const newMap = new Map(prev);
            newMap.set(producerInfo.userId, new MediaStream([consumer.track]));
            return newMap;
          });
        }
      } else if (!consumer) {
        // Fresh create
        const producer = producersState.get(producerId);
        if (producer) {
          createConsumer(sessionId || roomCode, producer.id, producer.kind);
        }
      } else if (consumer === "PAUSE_AFTER_CREATION") {
        consumers.current.set(producerId, "CREATING");
      }
    }
  });

  activeViewerVideoIdsRef.current = new Set(shouldBeActive);

}, [producersState, viewerVideoPage, pinnedViewerId, zoomed, thumbnailsExpanded, sessionId, roomCode]);

useEffect(() => {
  isRecordingRef.current = isRecording;
}, [isRecording]);

useEffect(() => { activeScreenShareRef.current = activeScreenShare; }, [activeScreenShare]);

useEffect(() => { screenCaptureActiveRef.current = screenCaptureActive; }, [screenCaptureActive]);

useEffect(() => { isRecordingRef.current = isRecording; }, [isRecording]);

useEffect(() => {
  screenCaptureStreamRef.current = screenCaptureStream;
}, [screenCaptureStream]);

useEffect(() => {
  userInteractedRef.current = userInteracted;
}, [userInteracted]);

useEffect(() => {
  const handleDeviceChange = async () => {
    try {
      addDebugLog("🎧 Media device change detected");

      const devices = await navigator.mediaDevices.enumerateDevices();

      const audioInput = devices.find(d => d.kind === "audioinput");

      if (!audioInput) return;

      addDebugLog(`🎤 Switching to new mic: ${audioInput.label}`);

      // Get new mic stream
      const newStream = await navigator.mediaDevices.getUserMedia({
        audio: {
          deviceId: audioInput.deviceId
        }
      });

      const newTrack = newStream.getAudioTracks()[0];

      // Find existing mic producer
      let micProducer = null;

      producers.current.forEach((producer) => {
        if (producer.appData?.source === "mic") {
          micProducer = producer;
        }
      });

      if (micProducer) {
        await micProducer.replaceTrack({ track: newTrack });

        addDebugLog("✅ Mic track replaced successfully");
      }

      // Update local mediaStream also
      if (mediaStream) {
        mediaStream.getAudioTracks().forEach(t => t.stop());
        mediaStream.addTrack(newTrack);
      }

    } catch (err) {
      console.error(err);
      addDebugLog(`❌ Device switch failed: ${err.message}`);
    }
  };

  navigator.mediaDevices.addEventListener(
    "devicechange",
    handleDeviceChange
  );

  return () => {
    navigator.mediaDevices.removeEventListener(
      "devicechange",
      handleDeviceChange
    );
  };

}, []);

// ==========================================
// AUTO-MIXER USE-EFFECT (For Dynamic Audio)
// ==========================================
useEffect(() => {
  // Agar recording on nahi hai ya mixer setup nahi hai, toh kuch mat karo
  if (!isRecording || !recordingAudioContextRef.current || !recordingDestinationRef.current) return;

  const audioCtx = recordingAudioContextRef.current;
  const dest = recordingDestinationRef.current;
  const currentActiveTrackIds = new Set();

  // Ek helper function jo naye track ko mixer mein jodta hai
  const addTrackToMixer = (track) => {
    if (!track || track.readyState === 'ended') return;
    currentActiveTrackIds.add(track.id);
    
    if (!connectedAudioSourcesRef.current) {
      connectedAudioSourcesRef.current = new Map();
    }
    
    // Agar track pehle se nahi juda hai, toh jod do
    if (!connectedAudioSourcesRef.current.has(track.id)) {
      try {
        const stream = new MediaStream([track]);
        const source = audioCtx.createMediaStreamSource(stream);
        source.connect(dest); // Aawaz ko recording destination mein bhejo
        connectedAudioSourcesRef.current.set(track.id, source);
        console.log(`🎙️ Added dynamic audio track to mixer: ${track.id}`);
      } catch (e) {
        console.warn("Error adding track to mixer", e);
      }
    }
  };

  // 1. Streamer ka Apna Mic daalo
  mediaStream?.getAudioTracks()?.forEach(track => addTrackToMixer(track));

  // 2. Viewers ka Audio (Mic + Screen Audio) daalo 
  // Tumhare code mein ye 'viewerAudios' Map mein store hota hai
  viewerAudios?.forEach((stream) => {
    stream?.getAudioTracks()?.forEach(track => addTrackToMixer(track));
  });

  // 3. Cleanup: Jo log meeting chhod gaye ya mic off kar diya, unki aawaz mixer se hatao
  if (connectedAudioSourcesRef.current) {
    connectedAudioSourcesRef.current.forEach((source, trackId) => {
      if (!currentActiveTrackIds.has(trackId)) {
        try { source.disconnect(); } catch (e) {}
        connectedAudioSourcesRef.current.delete(trackId);
        console.log(`🛑 Removed audio track from mixer: ${trackId}`);
      }
    });
  }

}, [isRecording, mediaStream, viewerAudios]); // 👈 Ab yahan tumhara actual state variable 'viewerAudios' hai
useEffect(() => {
  if (mediaStream && socket && isConnected && audioEnabled) {
    // Small delay to ensure everything is ready
    const timer = setTimeout(() => {
      startStreamerSpeakingDetection();
    }, 2000);
    
    return () => clearTimeout(timer);
  }
}, [mediaStream, socket, isConnected, audioEnabled]);

// Media stream milte hi speaking detection start karen
useEffect(() => {
  if (mediaStream && socket && isConnected) {
    // Small delay to ensure everything is ready
    const timer = setTimeout(() => {
      startSpeakingDetection();
    }, 2000);
    
    return () => clearTimeout(timer);
  }
}, [mediaStream, socket, isConnected]);

// Cleanup on component unmount
useEffect(() => {
  return () => {
    stopSpeakingDetection();
  };
}, []);

useEffect(() => {
  showAudioPermissionModalRef.current = showAudioPermissionModal;
}, [showAudioPermissionModal]);

useEffect(() => {
  latestResourcesRef.current = { mediaStream, screenCaptureStream, socket };
}, [mediaStream, screenCaptureStream, socket]);

const handleOpenWhiteboard = useCallback(() => {
  if (showWhiteboard) {
    handleCloseWhiteboard();
    return;
  }

  const whiteboardInfo = {
    title: session?.title || "Collaborative Whiteboard",
    roomCode: session?.roomCode || roomCode,
    streamerName: user?.name || "Streamer",
    streamerId: user?.id,
    sessionId: sessionId || roomCode,
    wsToken: token,
    allowViewersToDraw: true,
    isStreamer: true
  };

  setWhiteboardSessionInfo(whiteboardInfo);
  setShowWhiteboard(true);
  setZoomed({ type: "whiteboard", userId: "whiteboard", stream: null });
}, [showWhiteboard, session, roomCode, user, token, sessionId]); // Dependencies add karein [cite: 136, 137, 250, 256]

// ✅ CLOSE WHITEBOARD
const handleCloseWhiteboard = () => {
  setShowWhiteboard(false);
  // ✅ Cleanup ke baad hi session info null karo
  setTimeout(() => {
    setWhiteboardSessionInfo(null);
  }, 100);
  setZoomed(null);
  addDebugLog("📝 Whiteboard closed");
};

const handleRecordingToggle = async () => {
  if (isRecordingLoading || isRecordingStopping) {
    toast.info('Recording operation is already in progress. Please wait...');
    return;
  }

  if (!isRecording) {
    // Agar recording pehle hi ek baar ho chuki hai
    if (hasRecordingBeenUsed) {
      toast.warning("Recording can only be started once per session. Please reload the page to record again.", {
        position: "top-center",
        autoClose: 5000
      });
      return;
    }
    // Pehli baar start kar rahe hain toh instruction dikhao
    setShowStartInstructionModal(true);
  } else {
    // Stop karne se pehle confirmation mango
    setShowStopConfirmModal(true);
  }
};

const startRecording = async () => {
  try {
    setIsRecordingLoading(true);
    isRecordingStartingRef.current = true;
    addDebugLog(`🎬 Starting Recording`);

    if (!socket || !sessionId) throw new Error("Socket/sessionId missing");

    // ==========================================
    // 1. DEDICATED SCREEN CAPTURE FOR RECORDING
    // ==========================================
    const recordScreenStream = await navigator.mediaDevices.getDisplayMedia({
      video: {
        frameRate: { ideal: 30, max: 30 },
        width: { ideal: 1280, max: 1280 },
        height: { ideal: 720, max: 720 },
        resizeMode: "none"
      },
      audio: true // 👈 YAHAN TRUE KIYA TAAKI SYSTEM/TAB AUDIO BHI AAYE
    });

    // Agar user browser ke "Stop sharing" button pe click kar de
    const videoTrack = recordScreenStream.getVideoTracks()[0];
    if ("contentHint" in videoTrack) {
      videoTrack.contentHint = "detail";
      console.log("✅ Recording Video Track contentHint set to 'motion'");
    }
    videoTrack.onended = () => {
      addDebugLog("🛑 Dedicated recording screen share ended by user");
      if (isRecordingRef.current) {
        stopRecording(); // Stop backend recording as well
      }
    };

    // Save stream in ref so we can stop it later
    recordingScreenStreamRef.current = recordScreenStream;

    // Produce this dedicated video track to backend
    if (recordingVideoProducerRef?.current) {
      try { recordingVideoProducerRef.current.close(); } catch {}
    }
    // startRecording function ke andar videoProducer setup:
const videoProducer = await sendTransportRef.current.produce({
  track: videoTrack,
  appData: { source: "recording-video" },
  encodings: [
    { 
      maxBitrate: 1200000,      // 1.2 Mbps (Exact as requested)
      minBitrate: 300000,       // Fallback control: 600kbps se niche nahi girega
      maxFramerate: 30,         // 30 FPS
    }
  ],
  codecOptions: { 
    videoGoogleStartBitrate: 1000, // 1 Mbps se start hoga
    videoGoogleMinBitrate: 400     // Engine ko force karega low quality avoid karne ke liye
  }
});
    recordingVideoProducerRef.current = videoProducer;


    // ==========================================
    // 2. SETUP CUSTOM AUDIO MIXER 
    // (Streamer Mic + Dedicated Screen Audio)
    // ==========================================
    if (!recordingAudioContextRef.current) {
      recordingAudioContextRef.current = new AudioContext();
    }
    const audioCtx = recordingAudioContextRef.current;
    if (audioCtx.state === "suspended") {
      await audioCtx.resume();
    }

    // Naya Master Destination banayenge jahan sab mix hoga
    const dest = audioCtx.createMediaStreamDestination();
    recordingDestinationRef.current = dest;

    // A. Streamer ka apna Mic add karo
    let currentMicStream = mediaStream?.getAudioTracks?.()?.length > 0 ? mediaStream : null;
    if (currentMicStream) {
      const micSource = audioCtx.createMediaStreamSource(currentMicStream);
      micSource.connect(dest);
    }

    // B. Dedicated Screen ka System Audio add karo
    if (recordScreenStream.getAudioTracks().length > 0) {
      const screenSource = audioCtx.createMediaStreamSource(recordScreenStream);
      const gainNode = audioCtx.createGain();
      gainNode.gain.value = 0.5; // Screen ki aawaz ko thoda balance rakho taaki Mic clear rahe
      screenSource.connect(gainNode).connect(dest);
    }

    // Final mixed track nikal lo
    const mixedAudioTrack = dest.stream.getAudioTracks()[0];

    // ==========================================
    // 3. PRODUCE MIXED AUDIO
    // ==========================================
    if (mixedAudioTrack) {
      if (mixedAudioProducerRef?.current) {
        try { mixedAudioProducerRef.current.close(); } catch {}
      }
      const mixedProducer = await sendTransportRef.current.produce({
        track: mixedAudioTrack,
        appData: { source: "mixed-audio" }, // 👈 Backend isko dhoondh lega
      });
      mixedAudioProducerRef.current = mixedProducer;
    }

    // Wait slightly to let producers initialize on backend
    await new Promise(resolve => setTimeout(resolve, 800));

    // ==========================================
    // 4. TRIGGER BACKEND RECORDING
    // ==========================================
    socket.emit("server-recording-start", { sessionId, userId: user?.id });

    setIsRecording(true);
    isRecordingRef.current = true;
    startRecordingTimer();
    toast.success("🎬 Recording Started!");
    setTimeout(() => {
    const videoProducer = recordingVideoProducerRef.current;
    if (videoProducer && videoProducer.track) {
        console.log("🎯 Toggling video track to force I-Frame for FFmpeg...");
        
        // Track ko disable karo
        videoProducer.track.enabled = false;
        
        // 100ms baad wapas enable karo - ye browser ko hila dega aur wo I-Frame shoot karega!
        setTimeout(() => {
            videoProducer.track.enabled = true;
            console.log("✅ Track re-enabled, I-Frame should be sent!");
        }, 100);
    }
}, 2500);

  } catch (error) {
    console.error("Failed to start recording:", error);
    
    // Agar user ne screen share permission cancel kar di
    if (error.name === 'NotAllowedError') {
      toast.error("Screen sharing permission denied for recording");
    } else {
      toast.error("Failed to start recording");
    }

    // Cleanup midway failure
    if (recordingScreenStreamRef.current) {
      recordingScreenStreamRef.current.getTracks().forEach(t => t.stop());
      recordingScreenStreamRef.current = null;
    }

    setIsRecording(false);
    isRecordingRef.current = false;
  } finally {
    isRecordingStartingRef.current = false;
    setIsRecordingLoading(false);
  }
};

const startScreenShareForParticipants = async (screenStream, shareType = 'video') => {
  if (!sendTransportRef.current || !user) return;

  try {
    const videoTrack = screenStream.getVideoTracks()[0];
    if (!videoTrack) return;

    // ✅ 1. Content Hint dynamically set kar diya
    if ("contentHint" in videoTrack) {
      videoTrack.contentHint = shareType === 'text' ? "detail" : "motion";
    }

    // ✅ 2. Constraints: Video ke liye aapki settings, Text ke liye nayi settings
    try {
      const constraints = shareType === 'text'
        ? {
            frameRate: { ideal: 5, max: 15 }, // Text ke liye kam fps
            width: { ideal: 1920, max: 1920 }, // Text ke liye 1080p sharp
            height: { ideal: 1080, max: 1080 },
            resizeMode: "none",
          }
        : {
            // 👇 Aapki perfect Video settings as it is
            frameRate: { ideal: 30, max: 30 }, 
            width: { ideal: 1280, max: 1280 }, 
            height: { ideal: 720, max: 720 },
            resizeMode: "none",
          };

      await videoTrack.applyConstraints(constraints);
    } catch (e) {
      addDebugLog(`⚠️ Screen constraint lock failed: ${e.message}`);
    }

    let videoProducer;

    // ✅ 3. Encodings aur Bitrate: Type ke hisaab se
    try {
      const encodings = shareType === 'text'
        ? [
            {
              maxBitrate: 1000000, // 1.5 Mbps for sharp text
              maxFramerate: 15,
              networkPriority: 'high'
            }
          ]
        : [
            // 👇 Aapki perfect Video encoding settings as it is
            { 
              maxBitrate: 1000000, 
              maxFramerate: 30
            }
          ];

      videoProducer = await sendTransportRef.current.produce({
        track: videoTrack,
        stopTracks: false,
        appData: {
          source: "screen",
          userId: user.id,
          userName: user.name || "Streamer",
          shareType: shareType // Optional: Server/Viewers ko type pata chale isliye
        },
        encodings: encodings,
        codecOptions: { 
          // Text ke liye thoda zyada initial bitrate, video ke liye aapka default 800
          videoGoogleStartBitrate: shareType === 'text' ? 1000 : 800
        },
      });
    } catch (err) {
      // Safe Fallback
      videoProducer = await sendTransportRef.current.produce({
        track: videoTrack,
        stopTracks: false,
        appData: {
          source: "screen",
          userId: user.id,
          userName: user.name || "Streamer",
        }
      });
    }

    // --- Yahan se niche aapka original code exactly same hai ---
    if (videoProducer) {
      producers.current.set(videoProducer.id, videoProducer);
      setProducersState((prev) => new Map(prev).set(videoProducer.id, {
        id: videoProducer.id,
        kind: 'video',
        paused: false,
        source: 'screen'
      }));
      addDebugLog(`✅ Screen share VIDEO producer saved: ${videoProducer.id}`);
    }

    const audioTrack = screenStream.getAudioTracks()[0];
    if (audioTrack) {
      if ("contentHint" in audioTrack) {
        audioTrack.contentHint = "music";
      }

      const audioProducer = await sendTransportRef.current.produce({
        track: audioTrack,
        stopTracks: false,
        appData: {
          source: "screen-audio",
          userId: user.id,
          userName: user.name || "Streamer",
        },
      });

      if (audioProducer) {
        producers.current.set(audioProducer.id, audioProducer);
        setProducersState((prev) => new Map(prev).set(audioProducer.id, {
          id: audioProducer.id,
          kind: 'audio',
          paused: false,
          source: 'screen-audio'
        }));
      }
    }

    setActiveScreenShare({
      userId: user.id,
      userName: user.name || "Streamer",
      stream: screenStream,
      source: "streamer",
    });

    if (socket) {
      socket.emit("screen-share-started", {
        sessionId: sessionId || roomCode,
        userId: user.id,
        userName: user.name || "Streamer",
        hasAudio: !!audioTrack,
        source: "screen",
      });
    }
  } catch (error) {
    console.error("Error sharing screen:", error);
    addDebugLog(`❌ startScreenShareForParticipants error: ${error.message}`);
  }
};

const stopScreenShare = useCallback(async () => {
  addDebugLog("🛑 Stopping screen share...");

  // 1. Tell backend to stop forwarding
  if (socket && sessionId) {
    socket.emit("streamer-screen-share-stop", {
      sessionId,
      userId: user?.id,
      source: "streamer",
      forwardingOnly: false,
    });
  }

  // 2. Close Producers
  const isShareScreenSource = (src = "") =>
    src === "screen" || src === "screen-audio" ||
    src === "streamer-screen" || src === "streamer-screen-audio";

  const toDelete = [];
  producers.current?.forEach?.((producer, id) => {
    if (!isShareScreenSource(producer?.appData?.source || "")) return;
    try {
      producer.close();
      toDelete.push(id);
    } catch (err) {}
  });

  toDelete.forEach((id) => producers.current.delete(id));
  
  if (toDelete.length) {
    setProducersState((prev) => {
      const m = new Map(prev);
      toDelete.forEach((id) => m.delete(id));
      return m;
    });
  }

  // 3. Stop Local Tracks
  const shareObj = activeScreenShareRef?.current || activeScreenShare;
  if (shareObj?.source === "streamer" && shareObj?.stream) {
    try {
      shareObj.stream.getTracks?.().forEach((t) => {
        try { t.stop(); } catch {}
      });
    } catch (e) {}
  }

  // 4. Update UI States
  setZoomed((prev) => (prev?.type === "screen" ? null : prev));
  setActiveScreenShare((prev) => (prev?.source === "streamer" ? null : prev));
  
  // 5. Clean capture completely
  cleanupScreenCapture(true);

}, [socket, sessionId, roomCode, user, activeScreenShare, setProducersState, setActiveScreenShare, setZoomed]);

const stopRecording = useCallback(async () => {
  if (isRecordingStopping) return;
  const sid = sessionId || roomCode;

  try {
    addDebugLog("⏹️ Stopping SERVER recording...");
    setIsRecordingStopping(true);
    isRecordingRef.current = false;

    if (!socket || !sid) throw new Error("Socket/sessionId missing");

    await new Promise((resolve) => {
      socket.emit("server-recording-stop", { sessionId: sid }, (res) => resolve(res));
    });

    // ==========================================
    // 1. Dedicated Recording Producer Cleanup (NAYA)
    // ==========================================
    try {
      if (recordingVideoProducerRef?.current) {
        try { recordingVideoProducerRef.current.close(); } catch {}
        recordingVideoProducerRef.current = null;
        addDebugLog("🧹 Dedicated recording video producer closed");
      }
    } catch {}

    // ==========================================
    // 2. Dedicated Screen Capture Stream Cleanup (NAYA)
    // ==========================================
    try {
      if (recordingScreenStreamRef?.current) {
        recordingScreenStreamRef.current.getTracks().forEach(t => {
          try { t.stop(); } catch {}
        });
        recordingScreenStreamRef.current = null;
        addDebugLog("🧹 Dedicated recording screen stream killed");
      }
    } catch {}

    // ==========================================
    // 3. Mixed audio producer band karo
    // ==========================================
    try {
      if (mixedAudioProducerRef?.current) {
        try { mixedAudioProducerRef.current.close(); } catch {}
        mixedAudioProducerRef.current = null;
      }
    } catch {}

    // ==========================================
    // 4. Audio context cleanup
    // ==========================================
    try {
      if (recordingAudioContextRef.current) {
        try { recordingDestinationRef.current?.disconnect?.(); } catch {}
        await recordingAudioContextRef.current.close().catch(() => {});
        recordingAudioContextRef.current = null;
        recordingDestinationRef.current = null;
      }
    } catch {}

    // 👇 YAHAN SE cleanupScreenCapture() WALA OVERLAP HATA DIYA HAI 👇

    stopRecordingTimer?.();
    setIsRecording(false);
    setRecordingSource(null);
    toast.success("⏹️ Recording stopped!");

    // 👇 ✅ YAHAN UPDATE KIYA HAI: Recording stop hote hi flag true ho jayega
    setHasRecordingBeenUsed(true); 

  } catch (error) {
    console.error("stopRecording error:", error);
    toast.error(error?.message || "Failed to stop recording");
    setIsRecording(false);
    setRecordingSource(null);
  } finally {
    setIsRecordingStopping(false);
  }
}, [socket, sessionId, roomCode, isRecordingStopping, activeScreenShare, screenCaptureActive, cleanupScreenCapture, stopRecordingTimer]);



const handleWhiteboardPermission = useCallback((targetUserId, canDraw) => {
  // Server ko notify karein (jo ab Redis me save karega aur baakiyon ko broadcast karega)
  emitSocketEvent('update_whiteboard_permission', {
    sessionId: sessionId || roomCode,
    targetUserId: targetUserId,
    canDraw: canDraw
  });
  
  // Optimistic UI update: State ko turant update karein taaki UI fast feel ho
  setAllowedWhiteboardUsers(prev => {
    let updatedList;
    if (canDraw) {
      updatedList = [...new Set([...prev, targetUserId])]; // Add user
    } else {
      updatedList = prev.filter(id => id !== targetUserId); // Remove user
    }
    
    // ✅ Yahan se localStorage.setItem hata diya gaya hai
    return updatedList;
  });

  toast.success(`Whiteboard permission ${canDraw ? 'granted' : 'revoked'}`);
  addDebugLog(`✏️ Updated whiteboard permission for ${targetUserId} to ${canDraw}`);
}, [sessionId, roomCode, emitSocketEvent]);
// 1. Button click par sirf modal kholna hai (ya stop karna hai)
const handleStreamerScreenShareClick = () => {
  if (activeScreenShareRef.current?.source === "streamer") {
    stopScreenShare();
    return;
  }
  
  // Screen capture lene se pehle user se pucho ki kya share karna hai
  setShowShareTypeModal(true);
};

// 2. Modal se (text/video) select hone par ye chalega
const proceedWithScreenShare = async (shareType) => {
  // Modal band karo
  setShowShareTypeModal(false);

  try {
    const capture = await getOrCreateCapture("share");
    if (!capture) return;

    // ✅ Naya update: shareType pass kar rahe hain (text ya video)
    await startScreenShareForParticipants(capture, shareType);

    // ✅ Naya Trigger: Modal dikhayein taaki user click kare aur hum mute kar sakein
    setShowEchoSync(true); 

    // ✅ Safety: Turant mute karne ki koshish (agar browser allow kare)
    if (screenRef.current) {
        screenRef.current.muted = true;
        screenRef.current.volume = 0;
        screenRef.current.setAttribute("muted", "true");
    }

    setZoomed({ type: "screen", stream: capture, userId: user?.id });
  } catch (e) {
    console.error("proceedWithScreenShare error:", e);
    toast.error("Failed to start screen share");
  }
};

// Format file size helper
const formatFileSize = (bytes) => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};

// Cleanup on component unmount
useEffect(() => {
  return () => {
    // Cleanup recording
    // if (recorder && recorder.state === 'recording') {
    //   recorder.stop();
    // }
    
    // Cleanup media tracks
    if (mediaStream) {
      mediaStream.getTracks().forEach(track => track.stop());
    }
    
    // Cleanup window tracks
    if (window.recordingTracks) {
      window.recordingTracks.forEach(track => {
        if (track.readyState === 'live') {
          track.stop();
        }
      });
      window.recordingTracks = null;
    }
  };
}, []);


// Permission check useEffect ko update karo
useEffect(() => {
  const checkPermissions = async () => {
    try {
      addDebugLog('🔍 Checking camera and microphone permissions...');
      setPermissionStatus('checking');
      
      // Mobile devices ke liye direct request karo
      if (isMobile) {
        addDebugLog('📱 Mobile device detected, requesting permissions directly...');
        await initializeCamera();
        return;
      }
      
      // Desktop ke liye existing logic
      const devices = await navigator.mediaDevices.enumerateDevices();
      const hasVideoPermission = devices.some(device => device.kind === 'videoinput' && device.deviceId !== '');
      const hasAudioPermission = devices.some(device => device.kind === 'audioinput' && device.deviceId !== '');
      
      if (hasVideoPermission && hasAudioPermission) {
        addDebugLog('✅ Camera and microphone permissions already granted');
        setPermissionStatus('granted');
        initializeCamera();
      } else {
        addDebugLog('ℹ️ Need to request camera/microphone permissions');
        setPermissionStatus('denied');
        setIsLoading(false);
      }
    } catch (error) {
      console.error('Error checking permissions:', error);
      addDebugLog(`❌ Error checking permissions: ${error.message}`);
      setPermissionStatus('denied');
      setIsLoading(false);
    }
  };

  checkPermissions();
}, [isMobile]); // isMobile add karo dependency

useEffect(() => {
  if (!activeScreenShare?.stream) return;

  const alreadyOnSameScreen =
    zoomed?.type === "screen" && zoomed?.userId === activeScreenShare.userId;

  if (!alreadyOnSameScreen) {
    addDebugLog(`🔄 Auto-zooming to ${activeScreenShare.source} screen share`);
    setZoomed({
      type: "screen",
      stream: activeScreenShare.stream,
      userId: activeScreenShare.userId
    });
  }
}, [activeScreenShare?.stream, activeScreenShare?.userId, activeScreenShare?.source]);


useEffect(() => {
  const resumeAll = () => {
    document.querySelectorAll("audio").forEach((el) => {
      el.play().catch(() => {});
    });
    document.removeEventListener("click", resumeAll);
    document.removeEventListener("touchstart", resumeAll);
  };

  document.addEventListener("click", resumeAll, { once: true });
  document.addEventListener("touchstart", resumeAll, { once: true });

  return () => {
    document.removeEventListener("click", resumeAll);
    document.removeEventListener("touchstart", resumeAll);
  };
}, []);


useEffect(() => {
  const checkOrientation = () => {
    // Check if mobile and landscape
    const isLandscapeMode = window.innerWidth > window.innerHeight;
    setIsLandscape(isLandscapeMode);
    
    if (isMobile) {
      addDebugLog(`📱 Mobile orientation: ${isLandscapeMode ? 'Landscape' : 'Portrait'} (${window.innerWidth}x${window.innerHeight})`);
    }
  };

  // Initial check
  checkOrientation();

  // Listen for orientation changes
  window.addEventListener('resize', checkOrientation);
  window.addEventListener('orientationchange', checkOrientation);

  return () => {
    window.removeEventListener('resize', checkOrientation);
    window.removeEventListener('orientationchange', checkOrientation);
  };
}, [isMobile]);
useEffect(() => {
  const handleFirstUserInteraction = () => {
    addDebugLog('🎵 User interaction detected - enabling all audio');
    setUserInteracted(true);
    setShowAudioPermissionModal(false);
    playAllAudio();
    document.removeEventListener('click', handleFirstUserInteraction);
    document.removeEventListener('touchstart', handleFirstUserInteraction);
  };
  if (!userInteracted) {
    document.addEventListener('click', handleFirstUserInteraction, { once: true });
    document.addEventListener('touchstart', handleFirstUserInteraction, { once: true });
  }
  return () => {
    document.removeEventListener('click', handleFirstUserInteraction);
    document.removeEventListener('touchstart', handleFirstUserInteraction);
  };
}, [userInteracted]);

  useEffect(() => {
    viewerAudios.forEach((stream, userId) => {
      let audioEl = document.getElementById(`viewer-audio-${userId}`);
      if (!audioEl) {
        audioEl = document.createElement("audio");
        audioEl.id = `viewer-audio-${userId}`;
        audioEl.autoplay = true;
        audioEl.playsInline = true;
        audioEl.controls = false;
        document.body.appendChild(audioEl);
      }
      audioEl.srcObject = stream;
      audioEl.play().catch(err => {
        console.warn(`Autoplay prevented for ${userId}, waiting for user gesture`, err);
      });
    });
  }, [viewerAudios]);

  
const openRemoveAudioModal = (participant) => {
  setAudioRemoveTarget(participant);
};

const confirmRemoveAudio = () => {
  if (audioRemoveTarget) {
    handleMuteViewerAudio(audioRemoveTarget.socketId);
    setAudioRemoveTarget(null);
  }
}; 


const handleEnableAudio = () => {
  addDebugLog('🎵 User manually enabled audio - Syncing Echo Prevention');
  userInteractedRef.current = true;
  setUserInteracted(true);
  setShowAudioPermissionModal(false);

  // ✅ FIX: Agar Streamer khud screen share kar raha hai, to UI element ko MUTE karein
  // Taki speakers se awaaz na nikle aur mic mein wapas na jaye (Echo Loop Break)
  if (activeScreenShareRef.current?.source === "streamer" && screenRef.current) {
    screenRef.current.muted = true;
    screenRef.current.volume = 0;
    addDebugLog("🔇 Streamer local screen playback muted via gesture");
  }

  // Baaki sab audio (viewers) ko play karein
  playAllAudio();
};

const handleStopViewerScreenShare = useCallback((targetUserId) => {
    // 1. Server ko force-stop ka command bhejo
    emitSocketEvent('screen-share-force-stop', {
      sessionId: sessionId || roomCode,
      targetUserId
    });
    
    // 2. Web Viewer ka state locally clear karo
    setViewerScreenShare(prev => {
      if (prev?.userId?.toString() === targetUserId?.toString()) return null;
      return prev;
    });

    // 3. App Viewer ka state locally clear karo
    setAppViewerScreenShare(prev => {
      if (prev?.userId?.toString() === targetUserId?.toString()) return null;
      return prev;
    });

    // 4. Agar Streamer usko bada (zoom) karke dekh raha tha, toh zoom hatao
    setZoomed(prev => {
      if (
        prev && 
        (prev.type === "viewer-screen" || prev.type === "app-viewer-screen") && 
        prev.userId?.toString() === targetUserId?.toString()
      ) {
        return null;
      }
      return prev;
    });

    // 5. App screen share ke audio tags ko DOM se clean karo (Ghost audio fix)
    if (typeof cleanupScreenShareAudio === 'function') {
      cleanupScreenShareAudio(targetUserId);
    }
    
    addDebugLog(`Stopped screen share for user: ${targetUserId}`);
    toast.success("Viewer screen share stopped"); // Optional: Streamer ko feedback dene ke liye
    
  }, [sessionId, roomCode, setViewerScreenShare, setAppViewerScreenShare, setZoomed, cleanupScreenShareAudio, emitSocketEvent]);

  const handleViewerAudioResponse = useCallback((requesterSocketId, allow) => {
    emitSocketEvent('viewer-audio-response', {
      sessionId: sessionId || roomCode,
      requesterSocketId,
      allow
    });
    
    setViewerAudioRequests(prev => 
      prev.filter(req => req.requesterSocketId !== requesterSocketId)
    );
    
    if (allow) {
      addDebugLog(`Allowed audio for viewer: ${requesterSocketId}`);
    } else {
      addDebugLog(`Denied audio for viewer: ${requesterSocketId}`);
    }
  }, [sessionId, roomCode]);

  const handleScreenShareResponse = useCallback((requesterUserId, allow) => {
    emitSocketEvent('screen-share-response', {
      sessionId: sessionId || roomCode,
      requesterUserId,
      allow
    });
    
    setScreenShareRequests(prev => 
      prev.filter(req => req.requestedUserId !== requesterUserId)
    );
    
    if (allow) {
      addDebugLog(`Allowed screen share for viewer: ${requesterUserId}`);
    } else {
      addDebugLog(`Denied screen share for viewer: ${requesterUserId}`);
    }
  }, [sessionId, roomCode]);

  const handleMuteViewerAudio = useCallback((targetSocketId) => {
    emitSocketEvent('streamer-stop-viewer-audio', {
  sessionId: sessionId || roomCode,
  targetSocketId
});

    addDebugLog(`Muted viewer audio: ${targetSocketId}`);
  }, [sessionId, roomCode]);




// ✅ Add this useEffect to handle Zoomed Video without flickering
useEffect(() => {
  if (zoomedVideoRef.current && zoomed?.stream) {
    const videoEl = zoomedVideoRef.current;
    
    // Only update if stream ID is different to prevent flickering
    if (videoEl.srcObject?.id !== zoomed.stream.id) {
      videoEl.srcObject = zoomed.stream;
      videoEl.play().catch(e => console.warn("Zoomed video play error", e));
    }
  } else if (zoomedVideoRef.current && !zoomed) {
    zoomedVideoRef.current.srcObject = null;
  }
}, [zoomed, zoomed?.stream?.id]); // Only runs when zoomed user/stream changes

  // ========== STREAMING CONTROL FUNCTIONS ==========
  const startStreaming = async () => {
    const socket = getSocket();
    if (socket) {
      const hasProducers = producers.current.size > 0;
      
      if (hasProducers) {
        addDebugLog('ℹ️ Producers already exist, resuming if paused...');
        Array.from(producersState.entries()).forEach(([id, producer]) => {
          if (producer.paused) {
            handleResumeProducer(id);
          }
        });
      } else {
        addDebugLog('🔄 No producers found, initializing media...');
        await initializeMedia(sessionId || roomCode, iceServers);
      }
      
      emitSocketEvent('streamer_control', { 
        sessionId: sessionId || roomCode, 
        status: 'ACTIVE', 
        emitEvent: 'streamer_started' 
      });
      
      setRoomState(prev => ({ ...prev, isStreaming: true, isPaused: false }));
      setIsStreamPaused(false);
      setLocalPausedState(false);
    }
  };

  const pauseStreaming = () => {
    const socket = getSocket();
    if (socket) {
      Array.from(producersState.entries()).forEach(([id, producer]) => {
        if (!producer.paused) {
          handlePauseProducer(id);
        }
      });
      
      emitSocketEvent('streamer_control', { 
        sessionId: sessionId || roomCode, 
        status: 'PAUSED', 
        emitEvent: 'streamer_paused' 
      });
      
      setRoomState(prev => ({ ...prev, isPaused: true }));
      setIsStreamPaused(true);
      setLocalPausedState(true);
      
      if (videoRef.current && !videoRef.current.paused) {
        videoRef.current.pause();
      }
    }
  };

  const resumeStreaming = () => {
    const socket = getSocket();
    if (socket) {
      Array.from(producersState.entries()).forEach(([id, producer]) => {
        if (producer.paused) {
          handleResumeProducer(id);
        }
      });
      
      emitSocketEvent('streamer_control', { 
        sessionId: sessionId || roomCode, 
        status: 'ACTIVE', 
        emitEvent: 'streamer_resumed' 
      });
      
      setRoomState(prev => ({ ...prev, isPaused: false }));
      setIsStreamPaused(false);
      setLocalPausedState(false);
      
      if (videoRef.current && videoRef.current.paused) {
        videoRef.current.play().catch(error => {
          console.log('Resume play prevented:', error);
          setShowPlayButton(true);
          setLocalPausedState(true);
        });
      }
    }
  };

const endStreaming = async () => {
  // 1. Pehle user se confirm karein
  if (window.confirm('Are you sure you want to end the session for all participants?')) {
    
    // 2. Agar recording chal rahi hai, toh modal dikhayein aur yahin ruk jayein
    if (isRecording) {
      setShowEndSessionRecordingModal(true);
      return;   
    }

    // 3. Agar recording nahi hai, toh seedha session end karein
    actuallyEndSession();
  }
};

const actuallyEndSession = () => {
  // 4. Sabhi participants ke liye session end karne ka event bhejein
  emitSocketEvent('streamer_control', { 
    sessionId: sessionId || roomCode, 
    status: 'ENDED', 
    emitEvent: 'session_ended' 
  });

  // 5. Server ko session close command bhejein
  if (socket) {
    socket.emit("end-session", { sessionId: sessionId || roomCode });
  }

  // 2. 🚀 NAYA EVENT: Server ko sirf video merge aur upload karne ko bolo
  if (socket) {
    socket.emit("process-recording-upload", { sessionId: sessionId || roomCode });
  }

  // 6. Dashboard par redirect karein
  navigate("/dashboard");
};

const toggleAudio = () => {
  if (mediaStream) {
    const audioTrack = mediaStream.getAudioTracks()[0];
    if (audioTrack) {
      const newEnabledState = !audioTrack.enabled;
      audioTrack.enabled = newEnabledState;
      setAudioEnabled(newEnabledState);

      // Update producers
      Array.from(producersState.entries()).forEach(([id, producer]) => {
        if (producer.source === 'mic') {
          if (newEnabledState) {
            handleResumeProducer(id);
          } else {
            handlePauseProducer(id);
          }
        }
      });

      // 🎤 SPEAKING DETECTION CONTROL
      if (newEnabledState) {
        // Mic ON: Start speaking detection
        setTimeout(() => {
          startSpeakingDetection();
        }, 500); // Small delay to ensure audio track is ready
        
        // Also ensure speaking detection starts immediately for local state
        if (!audioContextRef.current) {
          // Force speaking detection initialization
          const initSpeakingDetection = () => {
            if (mediaStream && socket) {
              try {
                // Setup audio context
                const AudioContext = window.AudioContext || window.webkitAudioContext;
                audioContextRef.current = new AudioContext();
                
                const audioTracks = mediaStream.getAudioTracks();
                if (audioTracks.length === 0) return;
                
                // Create media stream source
                const streamSource = audioContextRef.current.createMediaStreamSource(mediaStream);
                
                // Create analyser
                analyserRef.current = audioContextRef.current.createAnalyser();
                analyserRef.current.fftSize = 256;
                analyserRef.current.smoothingTimeConstant = 0.8;
                
                // Connect source to analyser
                streamSource.connect(analyserRef.current);
                
                addDebugLog('🎤 Speaking detection audio context initialized');
              } catch (error) {
                console.error('Error initializing speaking detection:', error);
              }
            }
          };
          
          initSpeakingDetection();
        }
        
        addDebugLog(`🎤 Streamer mic ON - speaking detection started`);
      } else {
        // Mic OFF: Stop speaking detection
        stopSpeakingDetection();
        
        // Ensure we emit stop speaking event if currently speaking
        if (isSpeaking) {
          setIsSpeaking(false);
          if (socket) {
            socket.emit('user_stopped_speaking', {
              sessionId: sessionId || roomCode
            });
            addDebugLog(`🎤 Streamer stopped speaking due to mic off`);
          }
          
          // Also remove from local speaking state
          if (user?.id) {
            setSpeakingUsers(prev => {
              const newMap = new Map(prev);
              newMap.delete(user.id);
              return newMap;
            });
          }
        }
        
        addDebugLog(`🎤 Streamer mic OFF - speaking detection stopped`);
      }

      // Add toast notification
      toast.info(`Microphone ${newEnabledState ? 'enabled' : 'disabled'}`, {
        position: "bottom-right",
        autoClose: 2000,
      });
    }
  }
};

  const toggleVideo = () => {
    if (mediaStream) {
      const videoTrack = mediaStream.getVideoTracks()[0];
      if (videoTrack) {
        videoTrack.enabled = !videoTrack.enabled;
        setVideoEnabled(videoTrack.enabled);
        
        Array.from(producersState.entries()).forEach(([id, producer]) => {
          if (producer.source === 'camera') {
            if (videoTrack.enabled) {
              handleResumeProducer(id);
            } else {
              handlePauseProducer(id);
            }
          }
        });
        
        addDebugLog(`Video ${videoTrack.enabled ? 'enabled' : 'disabled'}`);
      }
    }
  };


const sendMessage = useCallback(async (text = '', file = null) => {
  try {
    let fileData = null;
    let fileName = null;
    let fileType = null;
    let fileSize = null;
    // Agar file hai to base64 mein convert karen (database ke bina direct transfer)
    if (file) {
      setUploadingFile(true);
      
      // File size check (max 5MB)
      if (file.size > 5 * 1024 * 1024) {
        toast.error('File size should be less than 5MB');
        setUploadingFile(false);
        return;
      }

      // File type check
      const allowedTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/webp', 'application/pdf', 'text/plain'];
      if (!allowedTypes.includes(file.type)) {
        toast.error('Only images, PDF and text files are allowed');
        setUploadingFile(false);
        return;
      }

      // File ko base64 mein convert karen for direct transfer
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = (e) => {
          // Base64 data (data:image/png;base64,XXXXXXXX ke format se prefix hata denge)
          const base64String = e.target.result;
          fileData = base64String.split(',')[1]; // Sirf base64 data le rahe hain
          fileName = file.name;
          fileType = file.type;
          fileSize = file.size;
          
          const messageData = {
            sessionId: sessionId || roomCode,
            message: text,
            fileData: fileData, // Direct base64 data
            fileName: fileName,
            fileType: fileType,
            fileSize: fileSize,
            timestamp: new Date().toISOString(),
            type: 'file' // Identify file message
          };

          emitSocketEvent('file_message', messageData);
          setUploadingFile(false);
          
          // Success feedback
          toast.success('File sent successfully!');
          resolve();
        };
        
        reader.onerror = () => {
          console.error('File reading error');
          setUploadingFile(false);
          toast.error('Failed to read file');
          resolve();
        };
        
        reader.readAsDataURL(file);
      });
    } else {
      // Normal text message
      const messageData = {
        sessionId: sessionId || roomCode,
        message: text,
        timestamp: new Date().toISOString(),
        type: 'text' // Identify text message
      };

      emitSocketEvent('chat_message', messageData);
    }
    
  } catch (error) {
    console.error('Error sending message:', error);
    setUploadingFile(false);
    toast.error('Failed to send message');
  }
}, [sessionId, roomCode]);

useEffect(() => {
  const trackId = mediaStream?.getVideoTracks?.()?.[0]?.id;
  if (!trackId) return;

  // ✅ Sirf tabhi aage badho jab koi aur cheez main stage na le rhi ho
  if (activeScreenShare || viewerScreenShare || appViewerScreenShare || showWhiteboard) return;

  // ✅ Agar user already apne camera par zoomed hai, to skip karo
  if (zoomed?.type === "streamer" && autoZoomedTrackIdRef.current === trackId) return;

  // ✅ Agar user ne kisi aur viewer par zoom kiya hua hai, to usko override mat karo
  if (zoomed && zoomed.type !== "streamer") return;

  // ✅ Mark & auto zoom back to streamer
  autoZoomedTrackIdRef.current = trackId;

  const videoOnly = getVideoOnlyStream(mediaStream);
  setZoomed({ type: "streamer", stream: videoOnly, userId: user?.id });

  // 🔥 MASTER FIX: Jab bhi wapas camera pe aaye to saare fake errors aur play icon hata do!
  setShowPlayButton(false);
  setMediaError(null);

  // optional: ensure play attempt (thoda delay diya hai taki render proper ho jaye)
  setTimeout(() => {
    if (videoRef.current) {
      videoRef.current.play().catch((err) => {
         console.log("Auto-play wait after reverting to camera", err);
      });
    }
  }, 100);

}, [
  mediaStream,
  user?.id,
  zoomed,
  activeScreenShare,
  viewerScreenShare,
  appViewerScreenShare,
  showWhiteboard,
  getVideoOnlyStream
]);

  // ========== USE EFFECT HOOKS ==========

useEffect(() => {
  // Initialize media stream refs
  streamerMediaRef.current = new MediaStream();
  viewerAudiosRef.current = new Map();

  return () => {
    isMountedRef.current = false;

    
    // 📺 SCREEN CAPTURE CLEANUP
    if (screenCaptureStream) {
      try {
        screenCaptureStream.getTracks().forEach(track => {
          if (track.readyState === 'live') {
            track.stop();
            addDebugLog(`🛑 Stopped screen capture track: ${track.kind}`);
          }
        });
      } catch (error) {
        console.error('Error stopping screen capture:', error);
      }
    }
    
    // 🧹 RECORDING STREAM CLEANUP
    if (recordingStream) {
      try {
        recordingStream.getTracks().forEach(track => {
          if (track.readyState === 'live') {
            track.stop();
          }
        });
        setRecordingStream(null);
        addDebugLog('🧹 Recording stream cleaned up');
      } catch (error) {
        console.error('Error cleaning recording stream:', error);
      }
    }

    // 🎥 Clean up main camera/microphone stream
    if (mediaStream) {
      try {
        mediaStream.getTracks().forEach(track => {
          if (track.readyState === 'live') {
            track.stop();
          }
        });
        addDebugLog('🎥 Main camera stream cleaned up');
      } catch (error) {
        console.error('Error stopping media stream:', error);
      }
    }

    // 🖥️ Clean up active screen share (only one can be active)
    if (activeScreenShare?.stream && activeScreenShare.stream !== screenCaptureStream) {
      try {
        activeScreenShare.stream.getTracks().forEach(track => {
          if (track.readyState === 'live') {
            track.stop();
          }
        });
        addDebugLog(`🖥️ Active screen share cleaned up: ${activeScreenShare.userName}`);
      } catch (error) {
        console.error('Error stopping active screen share:', error);
      }
    }

    // 🎤 Clean up all viewer audio streams
    viewerAudiosRef.current.forEach((stream, userId) => {
      try {
        stream.getTracks().forEach(track => {
          if (track.readyState === 'live') {
            track.stop();
          }
        });
      } catch (error) {
        console.error(`Error stopping viewer audio for ${userId}:`, error);
      }
    });

    // 🎥 Clean up remote video elements
    remoteVideosRef.current.forEach((video, producerId) => {
      try {
        if (video && video.srcObject) {
          video.srcObject.getTracks().forEach(track => track.stop());
          video.srcObject = null;
        }
      } catch (error) {
        console.error(`Error cleaning remote video ${producerId}:`, error);
      }
    });

    // 🔥 AUDIO MIXER CLEANUP
    if (audioContextRef.current) {
      try {
        audioContextRef.current.close();
        audioContextRef.current = null;
        audioDestinationRef.current = null;
        addDebugLog('🔊 Audio mixer cleaned up');
      } catch (error) {
        console.error('Error closing audio context:', error);
      }
    }

    // 🖱️ Remove gesture handlers
    if (userGestureHandlerRef.current) {
      try {
        document.removeEventListener("click", userGestureHandlerRef.current);
        document.removeEventListener("touchstart", userGestureHandlerRef.current);
        addDebugLog('🖱️ Gesture handlers removed');
      } catch (error) {
        console.error('Error removing gesture handlers:', error);
      }
    }

    // 🔌 Close all transports
    transports.current.forEach((transport, id) => {
      try {
        transport.close();
        addDebugLog(`🔌 Transport closed: ${id}`);
      } catch (error) {
        console.error(`Error closing transport ${id}:`, error);
      }
    });

    // 🔗 Close socket connection
    if (socketRef.current) {
      try {
        socketRef.current.close();
        addDebugLog('🔗 Socket connection closed');
      } catch (error) {
        console.error('Error closing socket:', error);
      }
    }

    // 🧹 CLEANUP PENDING AUDIO QUEUE
    pendingAudioQueueRef.current.forEach((streamInfo, userId) => {
      try {
        if (streamInfo.audioStream) {
          streamInfo.audioStream.getTracks().forEach(track => {
            if (track.readyState === 'live') {
              track.stop();
            }
          });
        }
      } catch (error) {
        console.error(`Error cleaning pending audio for ${userId}:`, error);
      }
    });
    pendingAudioQueueRef.current.clear();

    // 🧹 CLEANUP AUDIO ELEMENTS FROM DOM
    audioElementsRef.current.forEach((audioEl, userId) => {
      try {
        audioEl.pause();
        audioEl.srcObject = null;
        if (audioEl.parentNode) {
          audioEl.parentNode.removeChild(audioEl);
        }
      } catch (error) {
        console.error(`Error cleaning audio element for ${userId}:`, error);
      }
    });
    audioElementsRef.current.clear();

    // 🧹 CLEANUP VIEWER CAMERAS
    viewerCameras.forEach((stream, userId) => {
      try {
        stream.getTracks().forEach(track => {
          if (track.readyState === 'live') {
            track.stop();
          }
        });
      } catch (error) {
        console.error(`Error cleaning viewer camera for ${userId}:`, error);
      }
    });

    // 🧹 STATE RESET LOG
    addDebugLog('✅ Component cleanup completed');
    
    // TIMER CLEANUP (if any interval running)
    if (recordingInterval) {
      clearInterval(recordingInterval);
    }
    
  
  };
}, []); // Empty dependency array - runs only on unmount

  useEffect(() => {
    const checkPermissions = async () => {
      try {
        addDebugLog('🔍 Checking camera and microphone permissions...');
        setPermissionStatus('checking');
        
        const devices = await navigator.mediaDevices.enumerateDevices();
        const hasVideoPermission = devices.some(device => device.kind === 'videoinput' && device.deviceId !== '');
        const hasAudioPermission = devices.some(device => device.kind === 'audioinput' && device.deviceId !== '');
        
        if (hasVideoPermission && hasAudioPermission) {
          addDebugLog('✅ Camera and microphone permissions already granted');
          setPermissionStatus('granted');
          initializeCamera();
        } else {
          addDebugLog('ℹ️ Need to request camera/microphone permissions');
          setPermissionStatus('denied');
          setIsLoading(false);
        }
      } catch (error) {
        console.error('Error checking permissions:', error);
        addDebugLog(`❌ Error checking permissions: ${error.message}`);
        setPermissionStatus('denied');
        setIsLoading(false);
      }
    };

    checkPermissions();
  }, []);

  useEffect(() => {
    if (permissionStatus === 'granted' && !isWebSocketInitialized) {
      addDebugLog('🔄 Initializing WebSocket connection...');
      setIsWebSocketInitialized(true);
      initializeWebSocket();
    }
  }, [permissionStatus, isWebSocketInitialized]);

  useEffect(() => {
    const checkCameraVisibility = () => {
      if (videoRef.current && mediaStream) {
        const videoTracks = mediaStream.getVideoTracks();
        const hasVideo = videoTracks.length > 0 && videoTracks[0].readyState === 'live';
        
        if (hasVideo && videoRef.current.readyState >= 2) {
          setCameraVisible(true);
          setIsLoading(false);
          setIsInitializing(false);
          addDebugLog('✅ Camera video is visible on screen');
        }
      }
    };

    if (mediaStream) {
      checkCameraVisibility();
      const interval = setInterval(checkCameraVisibility, 500);
      return () => clearInterval(interval);
    }
  }, [mediaStream]);

  useEffect(() => {
    const videoElement = videoRef.current;
    
    if (!videoElement || !mediaStream) {
      setIsPlaying(false);
      return;
    }

    if (videoElement.srcObject !== mediaStream) {
      videoElement.srcObject = mediaStream;
      videoElement.muted = true;
    }

    const handlePlay = () => {
      console.log('Video started playing');
      setIsPlaying(true);
      setShowPlayButton(false);
      setMediaError(false);
      setLocalPausedState(false);
      setIsLoading(false);
    };

    const handlePause = () => {
      console.log('Video paused');
      setIsPlaying(false);
      setLocalPausedState(true);
      
      if (!roomState.isPaused) {
        setShowPlayButton(true);
      }
    };

    const handleError = (e) => {
      console.error('Video error:', e);
      setMediaError(true);
      setIsPlaying(false);
      setShowPlayButton(true);
    };

    const handleLoadedMetadata = () => {
      console.log('Video metadata loaded');
      setIsLoading(false);
      if (!roomState.isPaused && !localPausedState) {
        videoElement.play().catch(error => {
          console.log('Autoplay prevented:', error);
          setShowPlayButton(true);
        });
      }
    };

    const handleLoadedData = () => {
      console.log('Video data loaded');
      setIsLoading(false);
      if (videoElement.videoWidth > 0 && videoElement.videoHeight > 0) {
        setCameraVisible(true);
        setIsLoading(false);
      }
    };

    const handleCanPlay = () => {
      console.log('Video can play');
      setIsLoading(false);
    };

    videoElement.addEventListener('play', handlePlay);
    videoElement.addEventListener('pause', handlePause);
    videoElement.addEventListener('error', handleError);
    videoElement.addEventListener('loadedmetadata', handleLoadedMetadata);
    videoElement.addEventListener('loadeddata', handleLoadedData);
    videoElement.addEventListener('canplay', handleCanPlay);

    if (videoElement.readyState >= 2) {
      if (!videoElement.paused && !videoElement.ended) {
        setIsPlaying(true);
        setShowPlayButton(false);
        setLocalPausedState(false);
        setIsLoading(false);
      } else if (roomState.isPaused) {
        setIsPlaying(false);
        setShowPlayButton(false);
        setLocalPausedState(true);
      } else {
        videoElement.play().catch(error => {
          console.log('Initial play prevented:', error);
          setShowPlayButton(true);
          setLocalPausedState(true);
        });
      }
    }

    return () => {
      videoElement.removeEventListener('play', handlePlay);
      videoElement.removeEventListener('pause', handlePause);
      videoElement.removeEventListener('error', handleError);
      videoElement.removeEventListener('loadedmetadata', handleLoadedMetadata);
      videoElement.removeEventListener('loadeddata', handleLoadedData);
      videoElement.removeEventListener('canplay', handleCanPlay);
    };
  }, [mediaStream, roomState.isPaused]);

  useEffect(() => {
    const videoElement = videoRef.current;
    if (!videoElement || !mediaStream) return;

    if (roomState.isPaused && !videoElement.paused) {
      videoElement.pause();
      setIsPlaying(false);
      setShowPlayButton(false);
      setLocalPausedState(true);
    } else if (!roomState.isPaused && videoElement.paused && roomState.isStreaming) {
      videoElement.play().catch(error => {
        console.log('Play after resume prevented:', error);
        setShowPlayButton(true);
        setLocalPausedState(true);
      });
    }
  }, [roomState.isPaused, roomState.isStreaming, mediaStream]);

  useEffect(() => {
    if (mediaStream) {
      const tracks = mediaStream.getTracks();
      tracks.forEach(track => {
        addDebugLog(`Track: ${track.kind}, id: ${track.id}, enabled: ${track.enabled}, readyState: ${track.readyState}`);
        
        if (track.kind === 'video') {
          const settings = track.getSettings();
          addDebugLog(`Video settings: ${JSON.stringify({
            width: settings.width,
            height: settings.height,
            frameRate: settings.frameRate,
            deviceId: settings.deviceId
          })}`);
        }
      });
      
      const status = checkStreamStatus();
      if (status.hasVideo && status.hasAudio) {
        addDebugLog('✅ Stream has both audio and video tracks');
      } else {
        addDebugLog('❌ Stream is missing audio or video tracks');
      }
    }
  }, [mediaStream]);
// 👇 ye effect tumhare component me daal do
// ✅ Streamer video ke liye

const handlePlayClick = async (e) => {
  try {
    e.stopPropagation();
    console.log('📱 User triggered play');
    
    if (videoRef.current && mediaStream) {
      // Ensure video element is properly set up
      const videoEl = videoRef.current;
      videoEl.muted = true;
      videoEl.playsInline = true;
      videoEl.setAttribute('playsinline', '');
      videoEl.setAttribute('webkit-playsinline', '');
      
      // Set source only if needed
      if (videoEl.srcObject !== mediaStream) {
        videoEl.srcObject = mediaStream;
      }
      
      // User gesture ke saath play
      await videoEl.play();
      console.log('✅ Mobile video started via user gesture');
      setIsPlaying(true);
      setShowPlayButton(false);
      setMediaError(false);
      setLocalPausedState(false);
      
    }
  } catch (error) {
    console.error('❌ Failed to play video on mobile:', error);
    
    // Specific error handling
    if (error.name === 'NotAllowedError') {
      setMediaError('Autoplay blocked. Please tap to play.');
    } else {
      setMediaError('Failed to play video');
    }
    
    setShowPlayButton(true);
    setLocalPausedState(true);
  }
};

// Replace old handleViewerVideoResponse with this:
const handleViewerVideoResponse = useCallback((requesterSocketId, allow) => {
  // Use socketRef (safer) or emitSocketEvent helper
  if (!socketRef.current || !socketRef.current.connected) {
    addDebugLog('❌ Socket not connected — cannot send viewer-video-response');
    return;
  }

  socketRef.current.emit('viewer-video-response', {
    sessionId: sessionId || roomCode,
    requesterSocketId,    // <-- IMPORTANT: server expects this key
    allow                  // <-- IMPORTANT: server expects `allow` (boolean)
  });

  // remove the request UI
  setViewerVideoRequests(prev => prev.filter(r => r.userId !== requesterSocketId && r.socketId !== requesterSocketId));

  addDebugLog(`${allow ? '✅' : '❌'} Camera ${allow ? 'approved' : 'denied'} for requester socket: ${requesterSocketId}`);
}, [sessionId, roomCode]);

  const checkStreamStatus = useCallback(() => {
    if (!mediaStream) return false;
    
    const videoTracks = mediaStream.getVideoTracks();
    const audioTracks = mediaStream.getAudioTracks();
    
    const hasVideo = videoTracks.length > 0 && videoTracks[0].readyState === 'live';
    const hasAudio = audioTracks.length > 0 && audioTracks[0].readyState === 'live';
    
    addDebugLog(`Stream status - Video: ${hasVideo}, Audio: ${hasAudio}`);
    
    return { hasVideo, hasAudio };
  }, [mediaStream]);

useEffect(() => {
  if (!isMobile) return;

  const handleFirstUserInteraction = () => {
    addDebugLog('📱 Mobile user interaction detected');
    
    // Video play try karo user gesture ke baad
    if (videoRef.current && mediaStream && showPlayButton) {
      setTimeout(() => {
        videoRef.current.play().catch(() => {
          // Still blocked, play button show karo
          setShowPlayButton(true);
        });
      }, 100);
    }
  };

  // Multiple events pe listen karo
  document.addEventListener('click', handleFirstUserInteraction, { once: true });
  document.addEventListener('touchstart', handleFirstUserInteraction, { once: true });
  document.addEventListener('touchend', handleFirstUserInteraction, { once: true });

  return () => {
    document.removeEventListener('click', handleFirstUserInteraction);
    document.removeEventListener('touchstart', handleFirstUserInteraction);
    document.removeEventListener('touchend', handleFirstUserInteraction);
  };
}, [isMobile, mediaStream, showPlayButton]);

// Mobile detection and handlers
useEffect(() => {
  const checkMobile = () => {
    const mobile = window.innerWidth < 768 || 
                  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    setIsMobile(mobile);
    if (mobile) {
      setMobileView('video');
      setShowThumbnails(false);
      addDebugLog(`📱 Mobile device detected: ${window.innerWidth}px`);
    }
  };

  checkMobile();
  window.addEventListener('resize', checkMobile);
  
  return () => window.removeEventListener('resize', checkMobile);
}, []);

  // Full screen handling
  const toggleFullScreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen().catch(err => {
        console.log('Full screen error:', err);
      });
      setIsFullScreen(true);
    } else {
      document.exitFullscreen();
      setIsFullScreen(false);
    }
  };

// Render se thoda upar add karo:
const totalViewerProducersCount = Array.from(producersState.values()).filter(p => p.kind === 'video' && p.source === 'viewer-camera').length;
  // Mobile main render
  if (isMobile) {
      const mobileHeight = isLandscape ? 'h-[160vh]' : 'h-screen';

    return (
      <div className={`flex flex-col ${mobileHeight} bg-black text-white overflow-hidden`}>
        <MobileHeader
      session={session}
      participants={participants}
      isConnected={isConnected}
      viewerAudioRequests={viewerAudioRequests}
      screenShareRequests={screenShareRequests}
      viewerVideoRequests={viewerVideoRequests}
      setMobileView={setMobileView}
      toggleFullScreen={toggleFullScreen}
      isFullScreen={isFullScreen}
      showRequests={showRequests}
      setShowRequests={setShowRequests}
    />
    
    <MobileRequestsPanel
      viewerAudioRequests={viewerAudioRequests}
      screenShareRequests={screenShareRequests}
      viewerVideoRequests={viewerVideoRequests}
      handleViewerAudioResponse={handleViewerAudioResponse}
      handleScreenShareResponse={handleScreenShareResponse}
      handleViewerVideoResponse={handleViewerVideoResponse}
    />
        
        {mobileView === 'video' && (
        <MobileVideoView
          zoomed={zoomed}
          setZoomed={setZoomed}
          mediaStream={mediaStream}
          participants={participants}
          activeScreenShare={activeScreenShare}
          setIsPlaying={setIsPlaying}
          setShowPlayButton={setShowPlayButton}
          showPlayButton={showPlayButton}
          setMediaError={setMediaError}
          mediaError={mediaError}
          isLoading={isLoading}
          isInitializing={isInitializing}
          roomState={roomState}
          localPausedState={localPausedState}
          user={user}
          videoEnabled={videoEnabled}
          viewerCameras={viewerCameras}
          showMobileControls={showMobileControls}
          setShowMobileControls={setShowMobileControls}
          handlePlayClick={handlePlayClick}
          isPlaying={isPlaying}
        />
      )}
        {mobileView === 'participants' && <MobileParticipantsView
        participants={participants}
        activeSpeakers={activeSpeakers}
        handleMuteViewerAudio={handleMuteViewerAudio}
        emitSocketEvent={emitSocketEvent}
        sessionId={sessionId}
        roomCode={roomCode}
        addDebugLog={addDebugLog}
        handleStopViewerScreenShare={handleStopViewerScreenShare}
        handleBanParticipant={handleBanParticipant}
        bannedUsers={bannedUsers}
        handleUnbanParticipant={handleUnbanParticipant}
      />}
        {mobileView === 'chat' && <MobileChatView
        messages={messages}
        user={user}
        sendMessage={sendMessage}
        uploadingFile={uploadingFile}
        allowedWhiteboardUsers={allowedWhiteboardUsers}
      />}
        
       <MobileNavigation
      mobileView={mobileView}
      setMobileView={setMobileView}
      toggleFullScreen={toggleFullScreen}
      isFullScreen={isFullScreen}
    />
    
    <MobileControls
  toggleAudio={toggleAudio}
  audioEnabled={audioEnabled}
  toggleVideo={toggleVideo}
  videoEnabled={videoEnabled}
  roomState={roomState}
  startStreaming={startStreaming}
  resumeStreaming={resumeStreaming}
  pauseStreaming={pauseStreaming}
  endStreaming={endStreaming}
  // ✅ New props for recording
  handleRecordingToggle={handleRecordingToggle}
  isRecording={isRecording}
  isRecordingLoading={isRecordingLoading}
  isRecordingStopping={isRecordingStopping}
/>


      </div>
    );
  }

  // ========== MAIN RENDER ==========


// ========== MAIN RENDER ==========
if (
    (isLoading && permissionStatus !== 'denied') ||
    (permissionStatus === 'denied' && !isConnected) ||
    (!isConnected || !session)
  ) {
    return (
      <StreamLoadingStates
        isLoading={isLoading}
        permissionStatus={permissionStatus}
        isConnected={isConnected}
        session={session}
        mediaError={mediaError}
        initializeCamera={initializeCamera}
        requestCameraPermissions={requestCameraPermissions}
        videoRef={videoRef}
      />
    );
  }

  return (
    <div className="flex flex-col h-[115vh] bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white overflow-hidden">
      
      {/* 1. EXTRACTED HEADER COMPONENT */}
      <StreamHeader 
        session={session}
        isRecording={isRecording}
        recordingTimer={recordingTimer}
        formatRecordingTime={formatRecordingTime}
        isConnected={isConnected}
        pendingRequestsCount={viewerAudioRequests.length + screenShareRequests.length + viewerVideoRequests.length}
        sidebarCollapsed={sidebarCollapsed}
        setSidebarCollapsed={setSidebarCollapsed}
        endStreaming={endStreaming}
      />

      <div className="flex-1 overflow-hidden relative">
        {/* Thumbnails Full Screen Overlay */}
        {thumbnailsExpanded && (
          <div className="absolute inset-0 bg-black/95 backdrop-blur-sm z-40 flex flex-col">
            <div className="p-4 border-b border-gray-700 flex items-center justify-between bg-gray-800/90">
              <h2 className="text-xl font-bold flex items-center space-x-3">
                <FiVideo className="h-6 w-6 text-blue-400" />
                <span>All Streams ({thumbnailsCount})</span>
              </h2>
              <button onClick={() => setThumbnailsExpanded(false)} className="p-2 hover:bg-gray-700 rounded-lg">
                <FiX className="h-6 w-6" />
              </button>
            </div>
            <div className="flex-1 overflow-y-auto p-6">
              <ThumbnailsPanel
                variant="overlay"
                thumbnailsCount={thumbnailsCount}
                setThumbnailsExpanded={setThumbnailsExpanded}
                showWhiteboard={showWhiteboard}
                handleCloseWhiteboard={handleCloseWhiteboard}
                setShowPlayButton={setShowPlayButton}
                setZoomed={setZoomed}
                mediaStream={mediaStream}
                videoEnabled={videoEnabled}
                userId={user?.id}
                viewerCameras={viewerCameras}
                participantNameById={participantNameById}
                activeScreenShare={activeScreenShare}
                viewerScreenShare={viewerScreenShare}
                zoomed={zoomed}
                 
                // 👇 YEH 3 NAYE PROPS ADD KARNE HAIN 👇
                viewerVideoPage={viewerVideoPage}
                setViewerVideoPage={setViewerVideoPage}
                totalViewerProducersCount={totalViewerProducersCount}
                setPinnedViewerId={setPinnedViewerId}

              />
            </div>
            <div className="p-4 border-t border-gray-700 bg-gray-800/90 flex justify-between items-center">
              <div className="text-sm text-gray-400">Click on any stream to zoom into it</div>
              <button onClick={() => setThumbnailsExpanded(false)} className="px-6 py-2 bg-blue-600 rounded-lg">
                Back to Stream
              </button>
            </div>
          </div>
        )}

        <div className="flex h-full">
          {/* Main Video Area */}
          <div className="flex-1 flex flex-col min-h-0">
            <MainStage
              zoomed={zoomed}
              setZoomed={setZoomed}
              mediaStream={mediaStream}
              videoRef={videoRef}
              appViewerScreenShare={appViewerScreenShare}
              screenRef={screenRef}
              zoomedVideoRef={zoomedVideoRef}
              participants={participants}
              activeScreenShare={activeScreenShare}
              viewerScreenShare={viewerScreenShare}
              showWhiteboard={showWhiteboard}
              whiteboardSessionInfo={whiteboardSessionInfo || defaultAnnotationInfo} // ✅ Ab ye hamesha data pass karega
              ScreenAnnotationWhiteboard={ScreenAnnotationWhiteboard}
              StreamerWhiteboard={StreamerWhiteboard}
              handleCloseWhiteboard={handleCloseWhiteboard}
              isPlaying={isPlaying}
              isLoading={isLoading}
              isInitializing={isInitializing}
              showPlayButton={showPlayButton}
              mediaError={mediaError}
              videoEnabled={videoEnabled}
              handlePlayClick={handlePlayClick}
              retryCamera={retryCamera}
              renderSidebarToggleButton={() => (
                <div className="absolute right-4 top-4 z-50">
                  <button
                    onClick={(e) => { e.stopPropagation(); setSidebarCollapsed(!sidebarCollapsed); }}
                    className="bg-gray-800/80 hover:bg-gray-700/80 p-3 rounded-lg shadow-lg"
                    title={sidebarCollapsed ? "Show Sidebar" : "Hide Sidebar"}
                  >
                    {sidebarCollapsed ? <FiChevronLeft className="h-5 w-5 text-blue-400" /> : <FiChevronRight className="h-5 w-5 text-blue-400" />}
                  </button>
                </div>
              )}
            />
          </div>
          
          {/* Thumbnails Column - Always visible */}
          <div className="w-48 xl:w-56 flex flex-col bg-gray-800/80 border-l border-gray-600 z-30 h-full">
            <div className="p-4 border-b border-gray-600 flex items-center justify-between">
              <h3 className="font-semibold flex items-center space-x-2 text-sm">
                <FiVideo className="h-4 w-4 text-blue-400" />
                <span>Streams ({thumbnailsCount})</span>
              </h3>
              {thumbnailsCount > 0 && (
                <button onClick={() => setThumbnailsExpanded(true)} className="p-1 hover:bg-gray-700 rounded">
                  <FiMaximize className="h-4 w-4 text-gray-300" />
                </button>
              )}
            </div>
            <ThumbnailsPanel
              variant="column"
              thumbnailsCount={thumbnailsCount}
              appViewerScreenShare={appViewerScreenShare}
              setThumbnailsExpanded={setThumbnailsExpanded}
              showWhiteboard={showWhiteboard}
              handleCloseWhiteboard={handleCloseWhiteboard}
              setShowPlayButton={setShowPlayButton}
              setZoomed={setZoomed}
              mediaStream={mediaStream}
              videoEnabled={videoEnabled}
              userId={user?.id}
              viewerCameras={viewerCameras}
              participantNameById={participantNameById}
              activeScreenShare={activeScreenShare}
              viewerScreenShare={viewerScreenShare}
              zoomed={zoomed}

              // 👇 YEH 3 NAYE PROPS ADD KARNE HAIN 👇
             viewerVideoPage={viewerVideoPage}
             setViewerVideoPage={setViewerVideoPage}
             totalViewerProducersCount={totalViewerProducersCount}
             setPinnedViewerId={setPinnedViewerId}
            />
          </div>

          {/* 2. EXTRACTED SIDEBAR COMPONENT */}
          {!sidebarCollapsed && (
            <StreamSidebar 
              sidebarView={sidebarView}
              setSidebarView={setSidebarView}
              participants={participants}
              user={user}
              handRaisedUsers={handRaisedUsers}
              speakingUsers={speakingUsers}
              messages={messages}
              sendMessage={sendMessage}
              uploadingFile={uploadingFile}
              socket={socket}
              sessionId={sessionId}
              roomCode={roomCode}
              lowerAllHands={lowerAllHands}
              isSpeaking={isSpeaking}
              setShowParticipantsModal={setShowParticipantsModal}
              lowerHandForUser={lowerHandForUser}
              handleMuteViewerAudio={handleMuteViewerAudio}
              emitSocketEvent={emitSocketEvent}
              handleWhiteboardPermission={handleWhiteboardPermission}
              allowedWhiteboardUsers={allowedWhiteboardUsers} // 👈 NAYA PROP
              addDebugLog={addDebugLog}
            />
          )}
        </div>
      </div>

      <AudioPermissionModal isOpen={showAudioPermissionModal} onEnableAudio={handleEnableAudio} />

      {isRecording && !userInteracted && (
        <div className="fixed inset-0 bg-black/90 backdrop-blur-md flex items-center justify-center z-[9999]">
          <div className="bg-gray-800 p-8 rounded-2xl border border-blue-500/30 text-center max-w-md shadow-2xl mx-4">
            <div className="w-20 h-20 bg-blue-600/20 rounded-full flex items-center justify-center mx-auto mb-6">
              <FiVolume2 className="h-10 w-10 text-blue-400 animate-pulse" />
            </div>
            <h2 className="text-2xl font-bold mb-4 text-white">Optimize Audio</h2>
            <p className="text-gray-300 mb-8 text-sm">
              To prevent echo during screen recording, we need to sync your audio context. Please click the button below.
            </p>
            <button
              onClick={handleEnableAudio}
              className="w-full py-4 bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white rounded-xl font-bold flex items-center justify-center space-x-2"
            >
              <FiCheck className="h-5 w-5" />
              <span>Enable Echo-Free Audio</span>
            </button>
          </div>
        </div>
      )}

      {/* Panels and Modals */}
      <ViewerAudioRequestsPanel viewerAudioRequests={viewerAudioRequests} handleViewerAudioResponse={handleViewerAudioResponse} />
      <ScreenShareRequestsPanel screenShareRequests={screenShareRequests} handleScreenShareResponse={handleScreenShareResponse} />
      <ActiveViewerAudioPanel activeViewerAudio={activeViewerAudio} handleMuteViewerAudio={handleMuteViewerAudio} />
      <ActiveScreenSharesPanel activeScreenShare={viewerScreenShare || appViewerScreenShare} handleStopViewerScreenShare={handleStopViewerScreenShare} />
      <ParticipantsModal
        showParticipantsModal={showParticipantsModal}
        setShowParticipantsModal={setShowParticipantsModal}
        participants={participants}
        activeSpeakers={activeSpeakers}
        handleMuteViewerAudio={handleMuteViewerAudio}
        handleStopViewerScreenShare={handleStopViewerScreenShare}
        emitSocketEvent={emitSocketEvent}
        sessionId={sessionId}
        roomCode={roomCode}
        addDebugLog={addDebugLog}
        handleBanParticipant={handleBanParticipant}
        handleWhiteboardPermission={handleWhiteboardPermission}
        bannedUsers={bannedUsers}
        handleUnbanParticipant={handleUnbanParticipant}
        allowedWhiteboardUsers={allowedWhiteboardUsers}
      />
      <ViewerVideoRequestsPanel viewerVideoRequests={viewerVideoRequests} handleViewerVideoResponse={handleViewerVideoResponse} />

      {/* Remove Audio Confirmation Modal */}
      {audioRemoveTarget && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-2xl shadow-2xl max-w-sm text-gray-900">
            <div className="flex items-center space-x-3 mb-4">
              <FiAlertCircle className="h-6 w-6 text-red-500" />
              <h3 className="text-lg font-semibold">Remove Audio?</h3>
            </div>
            <p className="mb-6">Do you want to remove audio for <strong>{audioRemoveTarget.name || audioRemoveTarget.userId}</strong>?</p>
            <div className="flex justify-end space-x-3">
              <button onClick={() => setAudioRemoveTarget(null)} className="px-4 py-2 bg-gray-300 rounded-lg">Cancel</button>
              <button onClick={confirmRemoveAudio} className="px-4 py-2 bg-red-600 text-white rounded-lg">Remove Audio</button>
            </div>
          </div>
        </div>
      )}

      {showEndSessionRecordingModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl p-6 w-[420px] text-center shadow-xl">
            <h2 className="text-lg font-bold text-gray-800">🎬 Recording is still ON</h2>
            <p className="mt-3 text-gray-600">Do you want to save this recording before ending the session?</p>
            <div className="mt-5 flex justify-center gap-4">
              <button onClick={async () => { await stopRecording(); setShowEndSessionRecordingModal(false); actuallyEndSession(); }} className="bg-green-600 text-white px-5 py-2 rounded-lg">
                ✅ Save & End
              </button>
              <button onClick={() => { setShowEndSessionRecordingModal(false); actuallyEndSession(); }} className="bg-red-600 text-white px-5 py-2 rounded-lg">
                ❌ End Without Saving
              </button>
            </div>
          </div>
        </div>
      )}

      {/* 3. EXTRACTED BOTTOM CONTROLS */}
      <BottomControls 
        roomState={roomState}
        startStreaming={startStreaming}
        pauseStreaming={pauseStreaming}
        resumeStreaming={resumeStreaming}
        isInitializing={isInitializing}
        isRecordingLoading={isRecordingLoading}
        isRecordingStopping={isRecordingStopping}
        audioEnabled={audioEnabled}
        toggleAudio={toggleAudio}
        videoEnabled={videoEnabled}
        toggleVideo={toggleVideo}
        showWhiteboard={showWhiteboard}
        handleCloseWhiteboard={handleCloseWhiteboard}
        handleOpenWhiteboard={handleOpenWhiteboard}
        activeScreenShare={activeScreenShare}
        stopScreenShare={stopScreenShare}
        handleStreamerScreenShareClick={handleStreamerScreenShareClick}
        isRecording={isRecording}
        screenCaptureActive={screenCaptureActive}
        handleRecordingToggle={handleRecordingToggle}
        formatRecordingTime={formatRecordingTime}
        recordingTimer={recordingTimer}
        endStreaming={endStreaming}
      />
      {/* Start / Resume Prompt Modal Component */}
{/* ✅ UPDATED Start / Resume Prompt Modal Component */}
<StartResumePromptModal 
  showStartResumePrompt={showStartResumePrompt}
  onDismiss={() => {
    setIsPromptDismissed(true); // Modal hide karega
    setUserInteracted(true); // ✅ Browser ko batayega ki user active hai (Autoplay policy bypass)
    
    // ✅ Forcefully local video ko unlock karega bina stream tode
    if (videoRef.current && videoRef.current.paused) {
      videoRef.current.play().catch(e => console.log("Video unlock pending"));
    }
  }}
  roomState={roomState}
  resumeStreaming={resumeStreaming}
/>

      {/* Quick Status Bar Below Controls */}
      <div className="mt-2 mb-2 mx-auto max-w-2xl text-xs text-center text-gray-400">
        {(screenCaptureActive || activeScreenShare) && (
          <div className="flex items-center justify-center space-x-2">
            <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
            <span className="font-medium text-gray-300">
              {screenCaptureActive && !activeScreenShare ? 'Capture Ready' : activeScreenShare && isRecording ? 'Sharing + Recording' : 'Sharing Active'}
            </span>
          </div>
        )}
      </div>
      {/* Recording Modals */}
      <StartRecordingModal 
        isOpen={showStartInstructionModal} 
        onClose={() => setShowStartInstructionModal(false)} 
        onStart={startRecording} 
      />
      
      <StopRecordingModal 
        isOpen={showStopConfirmModal} 
        onClose={() => setShowStopConfirmModal(false)} 
        onStop={stopRecording} 
      />

      {/* Screen Share Content Type Modal */}
<ShareTypeModal 
  showShareTypeModal={showShareTypeModal}
  setShowShareTypeModal={setShowShareTypeModal}
  proceedWithScreenShare={proceedWithScreenShare}
/>

    </div>
  );
};

export default LiveSession;
